const messages = {
  es: {
    translations: {
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
      },
      common: {
          bulkCreatedSuccess: "{{count}} tareas creadas con éxito!",
          createBulkTask: "Crear Tarea para Tickets Seleccionados",
          createTasks: "Crear {{count}} Tareas",
          errorCreatingTasks: "Error al crear tareas",
          errorFetchingTickets: "Error al cargar tickets",
          noTasks: "Ninguna tarea creada",
          noTasksDescription: "Crea la primera tarea para comenzar a organizar el trabajo de este ticket",
          selectedTickets: "Tickets Seleccionados",
          taskInfo: "Información de la Tarea",
          ticketTasks: "Tareas del Ticket",
          viewTasks: "Ver Tareas",
        all: "Todos",
        actions: "Acciones",
        edit: "Editar",
        delete: "Eliminar",
        cancel: "Cancelar",
        save: "Guardar",
        close: "Cerrar",
        refresh: "Actualizar",
        refreshing: "Actualizando...",
        loading: "Cargando...",
        search: "Buscar",
        filter: "Filtrar",
        export: "Exportar",
        import: "Importar",
        add: "Añadir",
        create: "Crear",
        update: "Actualizar",
        view: "Visualizar",
        details: "Detalles",
        settings: "Configuraciones",
        test: "Probar",
        duplicate: "Duplicar",
        more: "Más",
        yes: "Sí",
        no: "No",
        confirm: "Confirmar",
        understood: "Entendido",
        rowsPerPage: "Filas por página",
        displayedRows: "{{from}}-{{to}} de {{count}}",
      },
      backDrop: {
        loading: "Cargando..."
      },
      pwa: {
        install: "Instalar App (PWA)",
        installIOS: "Instalar en iOS",
        alreadyInstalled: "App ya instalada",
        installSuccess: "¡App instalada con éxito!",
        installCanceled: "Instalación cancelada",
        installError: "Error al instalar la app",
        notSupported: "Tu navegador no soporta instalación de PWA",
        ios: {
          title: "Instalar App en iOS",
          subtitle: "Sigue los pasos a continuación para agregar esta app a tu pantalla de inicio",
          step1: {
            title: "Abre el menú de compartir",
            description: "Toca el ícono de compartir en la barra inferior de Safari"
          },
          step2: {
            title: "Agregar a Pantalla de Inicio",
            description: "Desplázate hacia abajo y toca 'Agregar a Pantalla de Inicio'"
          },
          step3: {
            title: "¡Listo!",
            description: "La app aparecerá en tu pantalla de inicio como una app nativa"
          },
          note: "Esta función solo está disponible en el navegador Safari de iOS"
        }
      },
      signup: {
        title: "Regístrate",
        toasts: {
          success: "Usuario creado con éxito! ¡Inicia sesión!",
          disabled:
            "El registro de usuarios está deshabilitado en este momento. Por favor, inténtalo de nuevo más tarde.",
          fail: "Error al crear usuario. Verifique los datos informados.",
          accountCreated: "Cuenta Creada",
          signupError: "Error en el Registro",
          emailExists: "El Email ya Existe",
          invalidData: "Datos Inválidos",
          signupDisabled: "Registro Deshabilitado",
          documentValid: "Documento Válido",
          documentInvalid: "Documento Inválido",
          companyFound: "Empresa Encontrada",
          validationError: "Error de Validación",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "Whatsapp (CÓDIGO + NÚMERO)",
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas rápidas",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        noPhone: "Ningún teléfono disponible para copiar",
        copyError: "Error al copiar teléfono",
      },
      login: {
        title: "Login",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          button: "Acceder",
        },
        buttons: {
          submit: "Entrar",
          register: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com éxito!",
          loginSuccess: "Inicio de Sesión Realizado",
          logoutSuccess: "Cierre de Sesión Realizado",
          authError: "Error de Autenticación",
          sessionExpired: "Sesión Expirada",
          subscriptionExpiring: "Suscripción por Vencer",
        },
        errorBoundary: {
          title: "¡Oops! Algo salió mal",
          description: "Detectamos um problema com o carregamento dos datos. Isso pode acontecer devido a problemas temporários de conectividade ou datos inválidos retornados do servidor.",
          genericDescription: "Ocorreu um error inesperado na aplicación. Tente recargar a página ou fazer login novamente.",
          buttons: {
            reload: "Recargar",
            login: "Iniciar Sesión",
            showDetails: "Mostrar detalles técnicos",
            hideDetails: "Ocultar detalles",
          }
        },
        dueDate: {
          expiration: "Tu suscripción expira en",
          days: "dias!",
          day: "dia!",
          expirationToday: "¡Tu suscripción expira hoy!",
        },
        token: "Token",
      },
      aiSuggestions: {
        title: "Sugerencias de IA",
        responseTitle: "Sugerencias de Respuesta",
        campaignTitle: "Sugerencias de Campanha",
        groupSummaryTitle: "Resumo de Conversación",
        buttons: {
          generate: "Gerar Sugerencias",
          refresh: "Actualizar",
          use: "Usar",
          copy: "Copiar",
          cancel: "Cancelar",
          close: "Cerrar",
          feedback: "Avaliar",
          helpful: "Útil",
          notHelpful: "No útil",
          used: "Utilizado",
          notUsed: "No utilizado",
        },
        messages: {
          generating: "Gerando sugerencias...",
          noSuggestions: "Nenhuma sugerencia disponível",
          error: "Error ao gerar sugerencias",
          configError: "Configuraciones de IA no encontradas",
          feedbackSuccess: "Feedback registrado com éxito",
          copied: "Copiado al portapapeles",
          used: "Sugerencia aplicada",
          loading: "Cargando...",
          validatingConfig: "Validando configuraciones...",
          configValid: "Configuraciones válidas",
          configInvalid: "Configuraciones inválidas",
        },
        response: {
          contextLabel: "Contexto da conversación",
          suggestionsLabel: "Sugerencias de respuesta",
          confidence: "Confiança",
          noContext: "Sem contexto de conversación disponível",
          analyzing: "Analisando conversación...",
          selectSuggestion: "Selecciona uma sugerencia",
        },
        campaign: {
          nameLabel: "Nombre de la campaña",
          baseMessageLabel: "Mensaje base (opcional)",
          productServiceLabel: "Produto/Serviço",
          targetAudienceLabel: "Público objetivo",
          campaignGoalLabel: "Objetivo de la campaña",
          toneLabel: "Tom da mensaje",
          additionalContextLabel: "Contexto adicional (opcional)",
          campaignTypeLabel: "Tipo de campaña",
          messageStyleLabel: "Estilo da mensaje",
          temperatureLabel: "Criatividade",
          maxTokensLabel: "Tamanho máximo",
          maxSuggestionsLabel: "Número de sugerencias",
          languageLabel: "Idioma",
          modelLabel: "Modelo de IA",
          templates: {
            promotional: "Promocional",
            informational: "Informativa",
            engagement: "Engajamento",
            retention: "Retención",
          },
          tones: {
            professional: "Profissional",
            casual: "Casual",
            promotional: "Promocional",
            empathetic: "Empático",
          },
          types: {
            promotional: "Promocional",
            informational: "Informativo",
            engagement: "Engajamento",
            retention: "Retención",
          },
          styles: {
            persuasive: "Persuasivo",
            educational: "Educativo",
            conversational: "Conversacional",
            empathetic: "Empático",
          }
        },
        groupSummary: {
          groupLabel: "Grupo",
          periodLabel: "Período",
          generateSummary: "Generar Resumen",
          summary: "Resumo da conversación",
          keyPoints: "Pontos principais",
          participants: "Participantes",
          messageCount: "Total de mensajes",
          timeRange: "Período analisado",
          noMessages: "Nenhuma mensaje encontrada no período seleccionado",
          analyzing: "Analisando conversación do grupo...",
        },
        configuration: {
          title: "Configuraciones de IA",
          apiKey: "Chave da API OpenAI",
          model: "Modelo",
          temperature: "Temperatura",
          maxTokens: "Tokens máximos",
          provider: "Provedor",
          autoShow: "Mostrar sugerencias automáticamente",
          enableFeedback: "Habilitar feedback",
          cacheResults: "Cache de resultados",
          validate: "Validar configuraciones",
          save: "Guardar configuraciones",
        }
      },
      dashboard: {
        title: "Dashboard",
        subtitle: "Sigue los principales indicadores y métricas de tu atención",
        sections: {
          keyMetrics: "Indicadores Principales",
          userActivity: "Estado de los Usuarios",
          nps: "Encuesta de Satisfacción (NPS)",
          attendanceInfo: "Información de Atención",
          ratingIndex: "Índice de Evaluación",
          attendants: "Atendentes",
          charts: "Análisis Gráficos",
        },
        filters: "Filtros",
        filter: "FILTRAR",
        buttons: {
          showFilters: "Filtros",
          hideFilters: "Ocultar Filtros",
          export: "Exportar",
          applying: "Aplicando...",
          loading: "Cargando...",
          filter: "Filtrar"
        },
        filters: {
          queue: "Cola",
          attendant: "Agente",
          allQueues: "Todas las Colas",
          allAttendants: "Todos los Agentes"
        },
        comparison: {
          enableComparison: "Comparar con período anterior",
          previous: "Anterior",
          vs: "vs",
          change: "Cambio",
          neutral: "Cambio neutral (< 5%)",
          improved: "Mejoró",
          worsened: "Empeoró",
          updatedAgo: "Actualizado hace {time}"
        },
        realtime: {
          autoRefresh: "Auto-actualización",
          enabled: "Activado",
          disabled: "Desactivado",
          lastUpdate: "Última actualización",
          secondsAgo: "hace {seconds}s",
          minutesAgo: "hace {minutes}min",
          justNow: "Ahora mismo"
        },
        alerts: {
          title: "Alertas del Dashboard",
          noAlerts: "Sin alertas activas",
          viewDetails: "Ver Detalles",
          severity: {
            high: "Alta",
            medium: "Media",
            low: "Baja"
          },
          types: {
            abandonmentHigh: "Tasa de Abandono Alta",
            waitTimeHigh: "Tiempo de Espera Alto",
            pendingHigh: "Muchos Tickets Pendientes",
            npsLow: "NPS Bajo"
          }
        },
        heatmap: {
          title: "Horarios Pico",
          subtitle: "Volumen de tickets por hora y día de la semana",
          days: {
            0: "Domingo",
            1: "Lunes",
            2: "Martes",
            3: "Miércoles",
            4: "Jueves",
            5: "Viernes",
            6: "Sábado"
          },
          legend: {
            low: "Bajo",
            medium: "Medio",
            high: "Alto",
            peak: "Pico"
          },
          tooltip: "{count} tickets el {day} a las {hour}h"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atenciones hoy: ",
          },
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "T.M. de Atención",
          averageWaitingTime: "T.M. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Quantidade de Atenciones",
          statusNow: "Atual",
          totalCallsUser: "Total de atenciones por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponible hasta",
        },
        assessments: {
          totalCalls: "Total de Atenciones",
          callsWaitRating: "Atenciones esperando evaluación",
          callsWithoutRating: "Atenciones sem evaluación",
          ratedCalls: "Atenciones avaliados",
          evaluationIndex: "Índice de Evaluación",
          score: "Score",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
        messages: {
          exportSuccess: "Informe exportado com éxito!",
          exportError: "Error ao exportar informe",
          loadError: "Error ao carregar datos do dashboard",
          ticketsError: "Error ao buscar información dos tickets",
        },
        toasts: {
          titles: {
            dashboardUpdated: "Dashboard Actualizado",
            dataLoaded: "Datos Carregados",
            dataError: "Error nos Datos",
          }
        }
      },
      groupSummaryModal: {
        title: {
          configure: "Configurar Resumen de Grupo",
          summary: "Resumen de la Conversaciónción",
        },
        subtitle: {
          configure: "Configura los parámetros para generar el resumen del grupo:",
          summary: "Resumen generado con IA •",
        },
        period: {
          title: "Período del Resumen",
          date: "Fecha",
          customPeriod: "Usar período personalizado",
          startTime: "Horario Inicial",
          endTime: "Horario Final",
          fullDayInfo: "Se analizará el día completo (00:00 a 23:59) de la fecha seleccionada.",
        },
        autoSend: {
          title: "Envío Automático",
          toggle: "Enviar resumen automáticamente al grupo",
          description: "A mensaje de resumo se enviada diretamente no grupo do WhatsApp",
          willSendTo: "El resumen se enviará a:",
        },
        advanced: {
          title: "Configuraciones Avanzadas",
          language: "Idioma del Resumen",
          length: "Tamaño del Resumen",
          includeStats: "Incluir estadísticas de participantes",
        },
        languages: {
          portuguese: "Português (Brasil)",
          english: "English (US)",
          spanish: "Español",
        },
        lengths: {
          short: "Corto",
          medium: "Medio",
          long: "Largo",
        },
        validation: {
          validConfig: "✓ Configuraciones válidas",
          invalidConfig: "✗ Configuraciones inválidas",
          model: "Modelo:",
          apiKey: "Clave API: Configurada",
        },
        sendStatus: {
          sentSuccess: "Resumo enviado com éxito!",
          sentTo: "A mensaje foi enviada para el grupo",
          generatedWithError: "Resumo gerado, mas houve error no envio",
          autoSendEnabled: "Envio automático estava habilitado, mas no foi possível confirmar o status.",
        },
        stats: {
          title: "📊 Estadísticas del Período",
          interactions: "interacciones",
          reactions: "reacciones",
          participants: "participantes",
          averagePerPerson: "promedio/persona",
        },
        readyMessage: {
          title: "📝 Mensaje Pronta para Envio",
        },
        sections: {
          topParticipants: "🏆 Top Participantes",
          mainTopics: "🔝 Principales Tópicos",
          keyDecisions: "✅ Decisiones Tomadas",
          importantQuestions: "❓ Preguntas Importantes",
          nextActions: "🎯 Próximas Acciones",
        },
        processingInfo: {
          title: "ℹ️ Información do Processamento",
          model: "Modelo:",
          period: "Período:",
          time: "Tiempo:",
          confidence: "Confianza:",
          sendStatus: "Envío:",
          sent: "✅ Enviado",
          failed: "❌ Falló",
        },
        buttons: {
          cancel: "Cancelar",
          generate: "Generar Resumen",
          generating: "Generando Resumen...",
          back: "Volver",
          copyFull: "Copiar Resumen Completo",
          copyMessage: "Copiar Mensaje",
          copyAlreadySent: "Copiar (Ya Enviado)",
          close: "Cerrar",
        },
        errors: {
          noAIConfig: "Configuraciones de IA no encontradas",
          aiConfigDescription: "Para usar a funcionalidade de resumo de grupos, é necesario que as configuraciones de IA estém definidas.",
          invalidTicket: "Ticket inválido",
          invalidTicketDescription: "Este ticket no es válido para generación de resumo de grupo.",
          invalidAIConfig: "Configuraciones de IA inválidas.",
          invalidAPIKey: "Clave de OpenAI inválida.",
          invalidData: "Datos inválidos para gerar resumo",
          serviceUnavailable: "Servicio de IA temporalmente no disponible.",
          generateError: "Error ao gerar resumo",
          copyError: "Error ao copiar",
        },
        toasts: {
          titles: {
            summaryGenerated: "Resumen Generado",
            summaryError: "Error no Resumo",
            dataExported: "Datos Exportados",
          },
          messages: {
            generatedAndSent: "Resumo gerado e enviado para el grupo com éxito!",
            generated: "Resumo gerado com éxito!",
            generatedWithSendError: "Resumo gerado com éxito, mas houve error ao enviar:",
            messageCopied: "Mensaje pronta copiada para área de transferência!",
            fullSummaryCopied: "¡Resumen completo copiado!",
          }
        }
      },
      reports: {
        title: "Informe de Encuestas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atenciones",
        search: "Encuestas",
        durationCalls: "Duración de las atenciones",
        grupoSessions: "Atenciones em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando informe compactado, por favor espera.",
          errorToast: "Error ao gerar o informe",
          back: "Volver",
          groupServiceReport: "Informe de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de apertura",
          dateLastUpdated: "Data Última Actualización",
          agent: "Quién atendió",
          agentClosed: "Quién cerró",
          waitingAssistance: "Esperando atención",
          process: "Em atención",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Informe de Encuestas Realizadas",
          activeSearch: "Búsqueda activa",
          inactiveSearch: "Búsqueda inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Gerando informe compactado, por favor espera.",
          title: "Informe de Duración do Atención",
          startService: "Início do atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Informe de Duración de las Atenciones",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Gerando informe compactado, por favor espera.",
          title: "Informe de Atención",
        },
        exportExcel: {
          title: "Informes de Atenciones",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Cola",
            status: "Estado",
            lastMessage: "Última Mensaje",
            openDate: "Fecha de Apertura",
            openTime: "Hora de Apertura",
            closeDate: "Fecha de Cierre",
            closeTime: "Hora de Cierre",
            supportTime: "Tempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizados",
          exportTitle: "Relación de Atenciones en Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarea",
        add: "Añadir",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para el Excel",
        buttons: {
          downloadModel: "Descargar modelo de excel para importación",
          closed: "Cerrar",
          import: "Selecciona o archivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espera... Tus conexiones se reiniciarán!",
        newConnection: "Nova Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar al Soporte",
        newConnection: "Nova Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atención para receber mensajes e iniciar conversaciones com tus clientes.",
        client: "Cliente",
        connectedConnections: " Conexiones conectadas ",
        disconnectedConnections: "Conexiones desconectadas ",
        totalConnections: " Total de Conexiones",
        total: "Total",
        connections: "Conexiones de:",

        toasts: {
          deleted: "Conexión eliminada com éxito!",
          closedimported:
            "Estamos fechando os tickets importados, por favor espera uns instantes",
          titles: {
            connectionCreated: "Conexión Creada",
            qrGenerated: "QR Generado",
            connectionRemoved: "Conexión Removida",
            connectionError: "Error na Conexión",
          }
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "Si confirmas, todos los tickets importados se cerrarán",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "¿Estás seguro? Necesitarás leer el QR Code novamente.",
        },
        buttons: {
          add: "Añadir Conexión",
          disconnect: "desconectar",
          tryAgain: "Intentar nuevamente",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos os tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes do WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensaje",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sesión do WhatsApp",
            content:
              "Asegúrate de que tu celular esté conectado a internet e intenta nuevamente, o solicita un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content:
              "Haz clic en el botón 'QR CODE' e lee el código QR con tu celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión estabelecida!",
          },
          timeout: {
            title: "A conexión com o celular foi perdida",
            content:
              "Asegúrate de que tu celular esté conectado a internet y WhatsApp esté abierto, ou haz clic en el botón 'Desconectar' para obtener un nuevo QR Code",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Cor",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atención Existente",
        },
        form: {
          message: "Este contato já está em atención:",
          user: "Atendente",
          queue: "Cola",
          messageWait:
            "Este contato já está esperando atención. Veja na aba Esperando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Cola definida.",
          open: " iniciou o atención.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió a la cola.",
          closed: "cerró el ticket",
          reopen: "reabrió el ticket",
          redirect: "- redirigido",
          clientClosed: "Cliente cerró el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Añadir Conexión",
          edit: "Editar Conexión",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes do aparelho",
          importOldMessages: "Fecha de inicio de la importación",
          importRecentMessages: "Fecha de término de la importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de importación",
          name: "Nombre",
          queueRedirection: "Redirección de Cola",
          queueRedirectionDesc:
            "Selecciona uma fila para els contatos que no possuem fila serem redirecionados",
          default: "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert:
            "ATENÇÃO: Ao guardar, tu conexión se encerrada, se necesario ler novamente o QR Code para importar as mensajes",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          maxUseInactiveTime: "Enviar flujo de inactividad x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          timeToReturnQueue: "Tiempo para volver a la cola en minutos",
          timeAwaitActiveFlow: "Tempo para esperar activación do fluxo",
          expiresTicket: "Cerrar chats abertos después de x minutos",
          expiresTicketNPS:
            "Cerrar chats esperando evaluación después de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que se enviará la evaluación",
          closeLastMessageOptions1: "Del agente/Cliente",
          closeLastMessageOptions2: "Del agente",
          outOfHoursMessage: "Mensaje de fora de expediente",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Enlace a la política de privacidad",
          lgpdMessage: "Mensaje de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensaje apagada pelo contato",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de inatividade",
          timeInactiveMessage:
            "Tiempo en minutos para envío del aviso de inactividad",
          flowInactiveTime:
            "Tiempo en minutos para envío del flujo de inactividad",
          whenExpiresTicket:
            "Cerrar chats abertos quando última mensaje for",
          expiresInactiveMessage: "Mensaje de encerramento por inatividade",
          prompt: "Prompt",
          promptHelp: "Configure um prompt personalizado para respuestas baseadas em IA. Para modos de agente avanzados, configure o Asistente de Voz na fila correspondente.",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensajes",
          isOficial: "Oficial",
          phone_number_id: "ID del Número de teléfono",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de teléfono",
          triggerIntegrationOnClose: "Disparar Integración ao Cerrar Ticket",
          enableIntegration: "Habilitar Integración",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos",
        },
        success: "Conexión guardado com éxito.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém no foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obligatorio informar um tempo para evaluación quando se utiliza o NPS.",
        errorRatingMessage:
          "É obligatorio informar uma mensaje de evaluación quando se utiliza o NPS.",
      },
      agentMode: {
        prompt: "Prompt",
        agentDirect: "Agente Directo",
        agentAssistant: "Asistente",
        promptTooltip: "IA funciona de forma autónoma usando prompts",
        agentDirectTooltip: "IA actúa como agente directo, puede ser controlada por humanos",
        agentAssistantTooltip: "IA proporciona sugerencias em tempo real para lagentes humanos",
        activeStatus: "IA Activa",
        inactiveStatus: "IA Inactiva",
        takeoverTooltip: "Assumir controle da conversación",
        aiResponding: "IA está respondiendo...",
        humanTookOver: "Agente humano asumió el control",
        aiTookOver: "IA asumió el control",
        transferredToAI: "Ticket transferido a IA",
        transferredToHuman: "Ticket transferido a agente humano",
        takeoverSuccess: "Controle transferido para lagente humano com éxito",
        takeoverButton: "Assumir Atención",
      },
      agentSuggestions: {
        title: "Sugerencias da IA",
        generating: "Gerando Sugerencias...",
        analyzing: "Analisando conversación...",
        noSuggestions: "Nenhuma sugerencia disponível no momento",
        accept: "Aceitar sugerencia",
        reject: "Rejeitar sugerencia",
        sendDirectly: "Enviar directamente",
        suggestionSent: "Sugerencia enviada com éxito",
        context: "Contexto",
        confidence: {
          high: "Alta",
          medium: "Media",
          low: "Baja",
        },
        actions: {
          accept: "Aceptar e Inserir",
          reject: "Rejeitar",
          send: "Enviar Directamente",
        }
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "Contato eliminado com éxito!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: " Flujos de Conversaciónción",
        addFlow: "Añadir Fluxo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "¿Estás seguro que quieres eliminar este contato? Se perderán todas las atenciones relacionadas.",
          blockContact: "¿Estás seguro que quieres bloquear este contato?",
          unblockContact: "¿Estás seguro que quieres desbloquear este contato?",
          importMessage: "Quieres importar todos os contatos do telefone?",
          importChat: "Importar Conversaciones",
          wantImport: "Quieres importar todas as conversaciones do telefone?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Añadir Contato",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          email: "Correo electrónico",
          actions: "Acciones",
          lastMessage: "Última Mensaje",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar de Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviado",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens en Respuesta",
          temperature: "Temperatura",
          max_messages: "Máximo de Mensajes en Histórico"
        },
        success: "Prompt guardado com éxito!",
        title: {
          add: "Añadir Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          model: "Modelo",
          max_tokens: "Máximo Tokens Respuesta",
          status: "Estado",
          actions: "Acciones",
          noPrompts: "No hay prompts registrados",
          noQueue: "Sin cola"
        },
        status: {
          active: "Activo",
          incomplete: "Incompleto"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Añadir Prompt",
          edit: "Editar",
          delete: "Eliminar"
        },
        toasts: {
          titles: {
            promptSaved: "Prompt Guardado",
            promptRemoved: "Prompt Eliminado",
            promptError: "Error no Prompt",
          }
        },
      },
      contactModal: {
        title: {
          add: "Añadir contato",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos do contato",
          extraInfo: "Información adicionais",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo electrónico",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          chatBotContact: "Deshabilitar chatbot",
          termsLGDP: "Términos LGPD aceptados en:",
          whatsapp: "Conexión Origem: ",
          assignWallet: "Cartera de Cliente",
        },
        buttons: {
          addExtraInfo: "Añadir información",
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contato guardado com éxito.",
        walletLinked: "Contato vinculado à sua carteira com éxito!",
        walletError: "Usuario no possui filas associadas",
        saveFirst: "Contato deve ser guardado primeiro",
      },
      wallets: {
        title: "Carteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos os usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Correo electrónico",
        actions: "Acciones",
        editWallet: "Editar Cartera",
        selectUser: "Selecionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Selecciona um usuario e uma fila",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Estás seguro que quieres remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com éxito!",
        updateSuccess: "Carteira atualizada com éxito!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Datos da fila",
          text: "Horários de atención",
          add: "Añadir fila",
          edit: "Editar cola",
          confirmationDelete:
            "¿Estás seguro? Se eliminarán todas las opciones de integraciones.",
        },
        form: {
          name: "Nombre",
          color: "Cor",
          orderQueue: "Orden de la cola (Bot)",
          rotate: "Rotación",
          timeRotate: "Tempo de Rotación",
          typeRandomMode: "Tipo de rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje de fora de expediente",
          token: "Token",
          tokenPlaceholder: "Token para autenticación en solicitudes n8n",
          integrationId: "Integración",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menú",
          message: "Mensaje de retorno",
          queue: "Cola para transferencia",
          integration: "Integración",
          file: "Lista de archivos",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Adicione opciones para construir um chatbot",
          toolTip:
            "Se houver apenas uma opción, ela se escolhida automáticamente, fazendo com que o bot responda com a mensaje da opción e siga adiante",
          selectOption: "Selecciona uma opción",
          text: "Texto",
          attendent: "Atendente",
          queue: "Cola",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle:
            "A mensaje é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensaje é obrigatória para seguir ao próximo nível",
          selectUser: "Selecciona um Usuario",
          selectQueue: "Selecciona uma Fila",
          selectIntegration: "Selecciona uma Integración",
          addOptions: "Añadir opciones",
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Añadir projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversación",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensaje ao reiniciar a conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
          assistantSelection: "Selecionar Agente IA",
          noAssistantSelected: "Nenhum agente seleccionado",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integración probada com éxito!",
          addSuccess: "Integración agregada com éxito.",
          editSuccess: "Integración editada com éxito.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importación das mensajes é necesario ler o qrCode novamente !!!",
        title: {
          add: "Añadir usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar imagem",
          removeImage: "Eliminar imagem",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexión Predeterminado",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de outros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atenciones",
          allowConnections: "Permitir acciones nas conexiones",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos",
        },
        tabs: {
          general: "Geral",
          permissions: "Permisos",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Añadir Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuario guardado com éxito.",
      },
      companyModal: {
        title: {
          add: "Añadir empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Empresa guardado com éxito.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Añadir agendamento",
        },
        success: "Agendamento guardado com éxito.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensaje de saludo da lane",
          rollbackLaneId: "Volver para Lane después de retomar atención",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag salva com éxito.",
        successKanban: "Lane salva com éxito.",
      },
      fileModal: {
        title: {
          add: "Añadir lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Añadir archivo",
        },
        form: {
          name: "Nome da lista de archivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar com archivo",
          extraValue: "Valor da opción",
        },
        success: "Lista de archivos salva com éxito!",
      },
      chat: {
        noTicketMessage: "Selecciona um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de archivo(s)",
        },
      },
      chatInternal: {
        new: "Crear grupo",
        modal: {
          conversation: "Conversación",
          title: "Nombre",
          filterUsers: "Selecciona integrantes",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
      },
      tickets: {
        messageHidden: "Mensaje oculta",
        inbox: {
          closedAllTickets: "Cerrar todos os tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abiertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atención que você estava foi deletado.",
        },
        notification: {
          message: "Mensaje de",
          messageHidden: "Mensaje oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atención e mensajes",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Programación",
          deleteTicket: "Eliminar Ticket",
        },
        aiControl: {
          pauseAI: "Pausar IA",
          resumeAI: "Reanudar IA",
          takeOwnership: "Asumir Atención",
          returnToAI: "Devolver a la IA",
          pauseSuccess: "IA pausada con éxito",
          resumeSuccess: "IA reanudada con éxito",
          takeOwnershipSuccess: "Atención asumida con éxito",
          returnToAISuccess: "Ticket devuelto a la IA con éxito",
        },
        closedTicket: {
          closedMessage: "Cerrar Ticket Com Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sem Mensaje de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecciona uma fila",
        fieldWhatsapp: "Selecciona um whatsapp",
        noOptions: "Nenhum usuario encontrado com esse nome",
        msgTransfer: "Observaciones - mensaje interna, no va para el cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Crear grupo",
        modal: {
          conversation: "Conversación",
          title: "Nombre",
          filterUsers: "Selecciona integrantes",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no pode ser revertida, confirmar?",
        },
      },
      messageInput: {
        agentTakeover: "Assumir Controle",
        aiActive: "IA Activa",
        aiSuggestion: "Sugerencia da IA disponível",
        useAISuggestion: "Usar sugerencia da IA",
        placeholderWithAI: "Digite sua mensaje ou use sugerencias da IA...",
        placeholderNormal: "Digite uma mensaje",
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        contactUnavailable: "Contato indisponível",
        pendingHeader: "Esperando",
        assignedHeader: "Atendendo",
        aiHeader: "IA",
        aiAssistant: "IA",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atención encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opciones de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Digite para buscar o contato",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para buscar o contato",
        add: "Añadir",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      timeMonitoring: {
        dashboard: {
          userActivity: {
            title: "Atividade dos Usuarios",
            active: "Ativos",
            inactive: "Inativos",
            offline: "Offline",
            tickets: "Tickets",
            hideDetails: "Ocultar detalles",
            showDetails: "Ver detalhes",
            inactiveFor: "Inactivo há",
            userStatus: {
              active: "Activo",
              inactive: "Inactivo",
              offline: "Offline",
            },
          },
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Painel",
          tickets: "Atenciones",
          quickMessages: "Respuestas rápidas",
          contacts: "Contactos",
          wallets: "Carteiras",
          landingPages: "Landing Pages",
          groups: "Grupos",
          assistants: "Asistentes IA",
          queues: "Filas & Chatbot",
          tags: "Etiquetas",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gestionar conexiones",
          reports: "Informes",
          management: "Gerência",
          utm: {
            generator: "Generador de Enlaces UTM",
            dashboard: "Dashboard UTM"
          },
        },
        search: {
          placeholder: "Buscar menu...",
        },
        mobile: {
          quickActions: "Acciones rápidas",
          searchMenu: "Buscar no menu",
          expandSection: "Expandir sección",
          collapseSection: "Contraer sección",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Activo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atención.",
            virtualAssistant: "Asistente Virtual",
          },
          language: "Idioma",
          volume: {
            on: "Som activado",
            off: "Som desactivado",
          },
          refresh: "Actualizar",
        },
        layoutSwitcher: {
          title: "Alternar Layout",
          subtitle: "Escolha o estilo de interface que preferir",
          currentLayout: "Layout Atual",
          switching: "Alterando Layout...",
          versions: {
            original: "Versión Original",
            v1_modern_sidebar: "Modern Sidebar",
            v2_top_navigation: "Top Navigation",
          },
          descriptions: {
            original: "Diseño predeterminado del sistema",
            v1_modern_sidebar: "Sidebar moderna com visual actualizado",
            v2_top_navigation: "Navegación superior horizontal",
          },
          loading: "Cargando",
          error: "Error: Layout no encontrado",
          beta: "BETA",
          new: "NEW",
        },
      },
      auth: {
        toasts: {
          success: "Login realizado com éxito!",
          fail: "Falha na validación de credenciais",
          badCredentials: "Usuario ou senha incorretos",
          suspended: "Usuario suspenso",
          disabled: "Usuario no possui permiso para lacessar a plataforma",
          noCompany: "Usuario no está associado a uma empresa",
          connectionLost: "Conexión com o servidor perdida",
          connectionRestored: "Conexión com o servidor restaurada",
          logout: "Logout realizado com éxito",
          token:
            "Token inválido, por favor entre em contato com o administrador da plataforma.",
        },
        message: {
          location: "Localización",
          contact: "Contacto",
        },
        notRegister: "Nenhum registro",
        refresh: "Actualizar",
      },
      assistants: {
        title: "Asistentes IA",
        searchPlaceholder: "Buscar assistentes...",
        buttons: {
          new: "Novo Asistente",
          help: "Ajuda",
          import: "Importar",
          edit: "Editar",
          delete: "Eliminar",
          train: "Treinar",
          addEmpty: "Crear Primeiro Asistente",
          cancel: "Cancelar",
          okAdd: "Añadir Asistente",
          okEdit: "Guardar Cambios",
          cancel: "Cancelar",
          cancelSelection: "Cancelar Selección",
          deleteSelected: "Eliminar Seleccionados",
          createSDR: "Crear Asistente SDR",
          createSDRTooltip: "Crear asistente preconfigurado para IA SDR con integración Apollo.io",
          createSDRTooltipManual: "Crear asistente SDR (modo manual - importación CSV). Configure Apollo.io para descubrimiento automático",
        },
        table: {
          name: "Nombre",
          model: "Modelo",
          tools: "Ferramentas",
          status: "Estado",
          actions: "Acciones",
        },
        modal: {
          title: {
            add: "Añadir Agente",
            edit: "Editar Agente",
          }
        },
        tools: {
          fileSearch: "Busca",
          fileSearchFull: "Busca em Archivos",
          codeInterpreter: "Código",
          codeInterpreterFull: "Interpretador de Código",
          function: "Función",
          functionFull: "Función Personalizada",
          availableTools: "Ferramentas Disponíveis",
          fileSearchDescription: "Permite buscar información em documentos",
          codeInterpreterDescription: "Executa código Python para análisis de datos",
          functionDescription: "Permite usar funciones personalizadas",
          fileSearchConfig: "Configure documentos para búsqueda",
          codeInterpreterConfig: "Configure archivos para análisis",
          functionConfig: "Configure funciones personalizadas",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        labels: {
          none: "Nenhum",
          voice: "Voz",
          transcription: "Transcripción",
          global: "Global",
        },
        emptyState: {
          title: "Nenhum assistente encontrado",
          description: "Crie seu primeiro assistente IA para começar a automatizar respuestas e melhorar o atención ao cliente.",
          noActive: "Nenhum assistente activo",
          noInactive: "Nenhum assistente inactivo",
          tryOtherTerms: "Tente usar outros termos na busca",
          noneInCategory: "No há assistentes nesta categoria",
        },
        tooltips: {
          voiceEnabled: "Recursos de voz habilitados",
          globalConfig: "Usando configuración global da empresa",
        },
        toasts: {
          loadError: "Error ao carregar assistentes",
          deleted: "Asistente eliminado com éxito",
          deleteError: "Error ao eliminar assistente",
        },
        confirmationModal: {
          deleteTitle: "Eliminar assistente",
          deleteMessage: "¿Estás seguro que quieres eliminar este assistente? Esta acción no pode ser desfeita.",
        },
        training: {
          title: "Treinamento com Contexto de Tickets",
          description: "Configure o treinamento do assistente com base no histórico de tickets da sua empresa para personalizar respuestas e melhorar a qualidade do atención.",
          maxTickets: "Máximo de Tickets",
          maxTicketsHelp: "Quantidade máxima de tickets para usar no treinamento (1-2000)",
          minMessages: "Mínimo de Mensajes",
          minMessagesHelp: "Número mínimo de mensajes por ticket para considerar no treinamento",
          startDate: "Fecha Inicial",
          endDate: "Fecha Final",
          queues: "Colas",
          queuesPlaceholder: "Selecciona as filas (deixe vazio para todas)",
          queuesHelp: "Especifique as filas para focar o treinamento em contextos específicos",
          includeClosed: "Incluir Tickets Fechados",
          onlySuccessful: "Apenas Tickets Resolvidos com Éxito",
          start: "Iniciar Treinamento",
          training: "Treinando...",
          cancel: "Cancelar",
          close: "Cerrar",
          progress: "Progresso do Treinamento",
          complete: "completo",
          success: "Treinamento Concluído!",
          successMessage: "O assistente foi treinado com éxito e está pronto para usar o conhecimento adquirido.",
          ticketsProcessed: "Tickets Processados",
          knowledgeItems: "Itens de Conhecimento",
          satisfaction: "Taxa de Satisfacción",
          companyProfile: "Perfil da Empresa",
          sector: "Sector",
          commonTopics: "Tópicos Comuns",
        },
        help: {
          title: "Ajuda sobre Agentes de IA",
          common: {
          bulkCreatedSuccess: "{{count}} tareas creadas con éxito!",
          createBulkTask: "Crear Tarea para Tickets Seleccionados",
          createTasks: "Crear {{count}} Tareas",
          errorCreatingTasks: "Error al crear tareas",
          errorFetchingTickets: "Error al cargar tickets",
          noTasks: "Ninguna tarea creada",
          noTasksDescription: "Crea la primera tarea para comenzar a organizar el trabajo de este ticket",
          selectedTickets: "Tickets Seleccionados",
          taskInfo: "Información de la Tarea",
          ticketTasks: "Tareas del Ticket",
          viewTasks: "Ver Tareas",
            capabilities: "Capacidades",
            supportedFormats: "Formatos suportados",
            field: "Campo",
            description: "Descripción",
            close: "Cerrar",
          },
          tabs: {
            introduction: "Introducción",
            creation: "Creación",
            tools: "Ferramentas",
            import: "Importación",
            messageTypes: "Tipos de Mensajes",
            apiIntegrations: "Integraciones de APIs",
          },
          introduction: {
            description: "Los Agentes de IA son asistentes virtuales basados en Inteligencia Artificial que pueden atender automáticamente a tus clientes.",
            whatAre: {
              title: "¿Qué son los Agentes de IA?",
              description: "Os Agentes de IA usam modelos avanzados de linguagem para elferecer atención automatizado, mas com respuestas naturais e personalizadas para tus clientes.",
              benefits: {
                personalization: "Personalización completa de las respuestas y comportamiento",
                contextMemory: "Memória de contexto para manter conversaciones coerentes",
                tools: "Utilización de herramientas avanzadas como búsqueda en archivos y análisis de datos",
                integration: "Integración perfeita com o fluxo de atención existente",
              }
            },
            page: {
              title: "A página de Agentes",
              description: "Esta página permite gestionar todos tus Agentes de IA, desde la creación hasta el monitoreo y edición.",
              sections: {
                creation: "Creación de Agentes",
                creationDesc: "Crie novos assistentes personalizados para necessidades específicas do seu negócio.",
                import: "Importación",
                importDesc: "Importe agentes já configurados na sua conta da OpenAI para usar aqui.",
                search: "Busca e Filtros",
                searchDesc: "Encontre rapidamente os agentes com filtros por modelo e ferramentas.",
                management: "Gerenciamento",
                managementDesc: "Edite, exclua ou desative agentes según necesario.",
              }
            },
            models: {
              title: "Modelos Disponíveis",
              description: "Escolha entre diferentes modelos de IA, cada um com características específicas de desempenho, qualidade e custo:",
              gpt4: "El modelo más avanzado, con mayor capacidad de comprensión y razonamiento complejo.",
              gpt4turbo: "Versión otimizada do GPT-4, oferecendo bom equilíbrio entre qualidade e velocidade.",
              gpt35: "Modelo rápido e econômico, ideal para tareas simples e de alto volume.",
              capabilities: {
                contextual: "Comprensión de contexto avanzada",
                reasoning: "Razonamiento complexo",
                code: "Generación de código de alta qualidade",
                analysis: "Análise de datos sofisticada",
                speed: "Velocidade otimizada",
                knowledge: "Conhecimento mais recente",
                costBenefit: "Boa relación custo-benefício",
                versatile: "Ideal para la maioria dos casos de uso",
                maxSpeed: "Velocidade máxima",
                lowCost: "Custo reduzido",
                simpleTasks: "Ideal para tareas simples",
                highScale: "Perfeito para lalta escala",
              },
              tip: {
                title: "Dica para escolha do modelo",
                description: "Para a maioria dos casos, o GPT-4 Turbo oferece o melhor equilíbrio entre qualidade e custo. Use o GPT-4 para casos que exigem razonamiento mais sofisticado e o GPT-3.5 para tareas simples em grande volume.",
              }
            }
          },
          creation: {
            title: "Criando um Agente",
            description: "El proceso de creación de un agente involucra algunos pasos simples, pero importantes para el buen funcionamiento del asistente.",
            stepsTitle: "Pasos para creación",
            steps: {
              one: {
                title: "Iniciar o processo",
                description: "Haz clic en el botón 'Añadir' no topo da página de Agentes para abrir o formulario de criação.",
              },
              two: {
                title: "Configuraciones básicas",
                description: "Preencha as información essenciais para el funcionamiento do agente:",
                fields: {
                  apiKey: "Chave da API OpenAI",
                  apiKeyDesc: "Sua chave pessoal da API da OpenAI para lautenticación dos serviços.",
                  name: "Nombre",
                  nameDesc: "Um nome identificador para el agente, visível apenas para você.",
                  instructions: "Instrucciones",
                  instructionsDesc: "Diretrizes detalladas que definem o comportamiento, tom e conhecimentos do agente.",
                  model: "Modelo",
                  modelDesc: "O modelo de IA a ser usado, que define capacidades e custos do agente.",
                }
              },
              three: {
                title: "Activar ferramentas",
                description: "Escolha as ferramentas que quieres disponibilizar para el seu agente:",
                tools: {
                  fileSearch: "Búsqueda de Archivos",
                  codeInterpreter: "Interpretador de Código",
                  functions: "Funciones Personalizadas",
                },
                note: "Cada ferramenta adiciona capacidades específicas e pode exigir configuraciones adicionais.",
              },
              four: {
                title: "Guardar o agente",
                description: "Haz clic en 'Añadir Agente' para finalizar la creación. El agente estará disponible inmediatamente para uso.",
              }
            },
            tips: {
              title: "Dicas para crear agentes eficazes",
              instructionsQuality: "Proporciona instrucciones detalladas y claras para obtener respuestas más precisas y en el tono deseado.",
              specificPurpose: "Crie agentes com propósitos específicos em vez de um único agente genérico para todas as tareas.",
              testIteratively: "Prueba el comportamiento del agente regularmente y ajusta las instrucciones según sea necesario.",
            }
          },
          tools: {
            title: "Ferramentas Disponíveis",
            description: "Os agentes pueden usar ferramentas especiais que ampliam suas capacidades para lalém da simples conversación por texto.",
            fileSearch: {
              title: "Búsqueda de Archivos",
              description: "Permite que o agente busque información em documentos carregados para responder preguntas com base em seu conteúdo.",
              capabilities: {
                retrieveInfo: "Recupera información específicas de documentos",
                answerQuestions: "Responde preguntas baseadas no conteúdo dos archivos",
                summarize: "Cria resumos e sínteses de documentos extensos",
              }
            },
            codeInterpreter: {
              title: "Interpretador de Código",
              description: "Permite que el agente ejecute código Python para análisis de datos, cálculos y generación de visualizaciones.",
              capabilities: {
                ejecuteCode: "Executa código Python para análisis de datos",
                dataAnalysis: "Realiza análises estatísticas e matemáticas",
                visualizations: "Gera gráficos e visualizaciones de datos",
              }
            },
            functions: {
              title: "Funciones Personalizadas",
              description: "Permite que o agente ejecute acciones específicas através de funciones definidas, como integración com sistemas externos.",
              capabilities: {
                integration: "Integración com sistemas e APIs externos",
                realTime: "Acesso a datos em tempo real",
                actions: "Execução de acciones específicas de negócio",
              }
            },
            configuration: {
              title: "Configuración das Ferramentas",
              description: "Cada ferramenta requer configuraciones específicas para seu funcionamiento adequado:",
              fileSearch: {
                title: "Configurando a Búsqueda de Archivos",
                step1: "Ative a ferramenta 'Búsqueda de Archivos' na aba Ferramentas.",
                step2: "Vá para la aba 'Archivos' e selecciona 'Búsqueda de Archivos' no tipo de ferramenta.",
                step3: "Adicione os archivos que quieres disponibilizar para consulta pelo agente.",
              },
              codeInterpreter: {
                title: "Configurando o Interpretador de Código",
                step1: "Ative a ferramenta 'Interpretador de Código' na aba Ferramentas.",
                step2: "Vá para la aba 'Archivos' e selecciona 'Interpretador de Código' no tipo de ferramenta.",
                libraries: "O ambiente Python inclui bibliotecas populares como pandas, numpy, matplotlib e scikit-learn por padrão.",
              },
              functions: {
                title: "Configurando Funciones Personalizadas",
                step1: "Ative a ferramenta 'Funciones Personalizadas' na aba Ferramentas.",
                step2: "Vá para la aba 'Funciones' e adicione as funciones que quieres disponibilizar para el agente.",
                parameters: {
                  title: "Configuración de Parâmetros",
                  name: "Nombre",
                  nameDesc: "Nome da función que o agente vai chamar",
                  description: "Descripción",
                  descriptionDesc: "Explicação do que a función faz e quando deve ser usada",
                  type: "Tipo",
                  typeDesc: "Tipo de dado do parâmetro (string, número, boolean, etc)",
                  required: "Obrigatório",
                  requiredDesc: "Indica se o parâmetro é obrigatório ou opcional",
                }
              }
            },
            limitations: {
              title: "Limitações",
              description: "As ferramentas têm algunos limitações importantes a considerar: o Interpretador de Código opera em um ambiente isolado sem acesso à internet, a Búsqueda de Archivos suporta um número limitado de formatos, e as Funciones Personalizadas requerem configuración adicional para implementação efetiva.",
            }
          },
          import: {
            title: "Importando Agentes",
            description: "Você pode importar agentes existentes da sua conta OpenAI para usar no sistema.",
            processTitle: "Processo de Importación",
            steps: {
              one: {
                title: "Iniciar importación",
                description: "Haz clic en el botón 'Importar' no topo da página de Agentes para abrir o assistente de importación.",
                note: "Você necesitará da sua chave de API da OpenAI para concluir este processo.",
              },
              two: {
                title: "Selecionar agentes",
                description: "O sistema mostrará todos os agentes disponíveis na sua conta OpenAI. Selecciona os que quieres importar.",
              },
              three: {
                title: "Concluir importación",
                description: "Clique em 'Importar Seleccionados' para finalizar o processo. Os agentes importados aparecerão na sua lista.",
                note: "Alguns elementos como archivos e funciones específicas pueden precisar ser reconfigurados después de a importación.",
              }
            },
            advantages: {
              title: "Vantagens da Importación",
              time: "Economiza tempo ao reutilizar agentes já configurados na OpenAI",
              consistency: "Mantém a consistência entre os agentes usados na plataforma OpenAI e no sistema",
              migration: "Facilita a migração gradual para el nosso sistema integrado",
            },
            limitations: {
              title: "Limitações da Importación",
              description: "Existem algunos limitações importantes a considerar no processo de importación:",
              files: {
                title: "Archivos",
                description: "Os archivos associados aos agentes na OpenAI no son importados automáticamente e precisam ser adicionados novamente.",
              },
              keys: {
                title: "Chaves API",
                description: "Você necesitará proporcionar sua chave API novamente para cada agente, mesmo que todos usem a mesma chave.",
              },
              functions: {
                title: "Funciones",
                description: "As funciones personalizadas precisarão ser reconfiguradas manualmente después de a importación.",
              }
            },
            security: {
              title: "Segurança",
              description: "Sua chave API da OpenAI é usada apenas para el processo de importación e interação com os agentes. Ela é armazenada de forma segura e criptografada em nosso sistema.",
            }
          },
          messageTypes: {
            title: "Tipos de Mensajes Suportadas",
            description: "O agente pode enviar vários tipos de mensajes além de texto simples. Veja abaixo os formatos suportados e como usá-los.",
            text: {
              title: "Mensaje de Texto",
              description: "Mensajes de texto simples son enviadas automáticamente. O agente pode responder com parágrafos, listas e formatação básica.",
              example: "Exemplo:",
              exampleText: "Olá! Como posso ajudar você hoje?",
            },
            location: {
              title: "Localización (Mapa)",
              description: "Envie coordenadas geográficas para mostrar uma localización no mapa.",
              example: "Formato:",
            },
            document: {
              title: "Documentos",
              description: "Envie documentos como PDF, DOC, XLS e outros formatos de archivo.",
              example: "Formato:",
            },
            video: {
              title: "Vídeos",
              description: "Compartilhe vídeos a partir de URLs externas.",
              example: "Formato:",
            },
            contact: {
              title: "Contactos",
              description: "Compartilhe información de contato que pueden ser salvas na agenda do usuario.",
              example: "Formato:",
            },
            audio: {
              title: "Áudios",
              description: "Envie mensajes de voz ou áudio a partir de URLs externas.",
              example: "Formato:",
            },
            image: {
              title: "Imagens",
              description: "Compartilhe imagens a partir de URLs externas ou geradas pelo agente.",
              example: "Formato:",
            },
            tips: {
              title: "Dicas para el uso de mensajes",
              description: "Para usar estes recursos, inclua comandos especiais nas instruções do seu agente. Os comandos devem ser formatados exatamente como mostrado nos exemplos acima. Múltiplos comandos pueden ser combinados em uma única respuesta.",
            }
          },
          apiIntegrations: {
            title: "Integraciones de APIs Externas",
            description: "Os assistentes pueden consultar APIs externas para enriquecer suas respuestas com datos em tempo real. Isso permite que o assistente acesse información atualizadas de sistemas externos, como vendas, pagamentos, estoque, e muito mais.",
            plugpix: {
              title: "API PlugPix - Pagamentos",
              description: "A integración PlugPix permite que o assistente consulte información sobre transações de pagamento, calcule taxas e proporciona datos de vendas em tempo real.",
              capabilities: {
                title: "Funcionalidades Disponíveis:",
                listTransactions: "Listar transações com paginação e filtros",
                getTransaction: "Consultar detalhes de uma venda específica",
                calculateFees: "Calcular taxas para diferentes formas de pagamento",
                paymentInfo: "Información sobre cartão, PIX e boleto",
                buyerData: "Datos do comprador e status da transação",
              }
            },
            configuration: {
              title: "Como Configurar",
              description: "Para habilitar a integración com APIs externas, siga os passos abaixo:",
              steps: {
                one: {
                  title: "Obter Credenciais da API",
                  description: "Entre em contato com o suporte da PlugPix para obtener suas credenciais de acesso: Endpoint, Marketplace ID, Seller ID e Token de autenticación.",
                  note: "As credenciais son únicas para cada empresa e devem ser mantidas em segurança.",
                },
                two: {
                  title: "Configurar no Asistente",
                  description: "Ao crear ou editar um assistente, vá para la aba 'Configuraciones de APIs' e preencha os campos da sección PlugPix com suas credenciais.",
                },
                three: {
                  title: "Activar Function Calling",
                  description: "Na aba 'Ferramentas', ative a opción 'Function Calling' para permitir que o assistente ejecute funciones customizadas.",
                },
                four: {
                  title: "Añadir Definições de Funciones",
                  description: "Na aba 'Funciones', adicione as definições das funciones PlugPix. Você pode copiar do archivo de template ou crear manualmente.",
                  functions: {
                    title: "Funciones Disponíveis:",
                    listTransactions: "plugpix_list_transactions - Lista transações",
                    getTransaction: "plugpix_get_transaction - Detalhes de uma transação",
                    calculateFees: "plugpix_calculate_fees - Calcula taxas de pagamento",
                  }
                },
                five: {
                  title: "Configurar Instrucciones",
                  description: "Adicione contexto nas instruções do assistente para que ele saiba quando e como usar as funciones da API.",
                  example: "Você tem acesso à API PlugPix para consultar\ninformações sobre transações e vendas.\n\nQuando o usuario perguntar sobre:\n- Vendas recentes: use plugpix_list_transactions\n- Uma venda específica: use plugpix_get_transaction\n- Taxas ou custos: use plugpix_calculate_fees",
                }
              }
            },
            examples: {
              title: "Exemplos de Uso",
              exampleOne: {
                question: "Pregunta do Usuario:",
                questionText: "Quais foram as últimas 10 vendas?",
                action: "Acción do Asistente:",
                actionText: "Chama automáticamente plugpix_list_transactions com limit=10 e apresenta os resultados de forma clara e organizada.",
              },
              exampleTwo: {
                question: "Pregunta do Usuario:",
                questionText: "Quanto fica R$ 150 em 3x no cartão Visa?",
                action: "Acción do Asistente:",
                actionText: "Chama plugpix_calculate_fees e retorna os valores com taxas para cada parcela de forma compreensível.",
              }
            },
            security: {
              title: "Segurança das Credenciais",
              storedSecurely: "As credenciais son armazenadas de forma segura no banco de datos",
              separateCredentials: "Cada assistente pode ter suas próprias credenciais",
              tokenProtection: "O token nunca é exposto nas respuestas ou logs",
              autoAuth: "Todas as requisições son autenticadas automáticamente",
            },
            tips: {
              title: "Dicas para Melhores Resultados",
              testFirst: "Teste com preguntas simples primeiro para verificar se a integración está funcionando",
              refineInstructions: "Refine as instruções do assistente basado nos resultados obtidos",
              monitorLogs: "Monitore os logs do backend para lacompanhar as chamadas à API",
              addExamples: "Adicione exemplos específicos do seu negócio nas instruções do assistente",
            }
          }
        },
        tabs: {
          basicSettings: "Configuraciones Básicas",
          tools: "Ferramentas",
          files: "Archivos",
          functions: "Funciones",
        },
        form: {
          name: "Nombre",
          instructions: "Instrucciones",
          model: "Modelo",
          active: "Activo",
          activeHelp: "Determina se o assistente estará disponível para uso",
          toolType: "Tipo de Ferramenta",
          toolTypeHelp: "Selecciona o tipo de ferramenta para els archivos",
          addFiles: "Añadir Archivos",
          newFiles: "Novos Archivos",
          existingFiles: "Archivos Existentes",
          noFiles: "Nenhum archivo encontrado",
        },
        validation: {
          tooShort: "Muito curto",
          tooLong: "Muito longo",
          required: "Campo obrigatório",
        },
        functions: {
          enableFirst: "Ative a ferramenta 'Función' primeiro para configurar funciones personalizadas",
        },
        toasts: {
          success: "Asistente guardado com éxito",
          saveError: "Error ao guardar assistente",
          loadAssistantError: "Error ao carregar assistente",
          loadFilesError: "Error ao carregar archivos",
          fileRemoved: "Archivo removido com éxito",
          fileRemoveError: "Error ao remover archivo",
          fileFormatNotAllowed: "Formato de archivo no permitido",
          fileSizeExceeded: "Tamanho máximo de archivo excedido",
        }
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID do usuario/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentação para envio de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, é necesario o registro do token vinculado à conexión que enviará as mensajes. <br />Para realizar o registro acesse o menu 'Conexiones', haz clic en el botón editar da conexión e insira o token no devido campo.",
            comments2:
              "O número para envio no deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "Seguem abaixo a lista de información necessárias para envio das mensajes de texto:",
          },
          media: {
            title: "2. Mensajes de Media",
            instructions:
              "Seguem abaixo a lista de información necessárias para envio das mensajes de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensaje oculta",
        newMessage: "Nova mensaje de",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecciona um fluxo para executar neste ticket. O ticket se alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo seleccionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo activo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com éxito!",
        error: "Error ao disparar fluxo",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Excluson",
          deleteMessage: "Esta acción é irreversível! Quieres prosseguir?",
        },
        selectMessage: "Selecionar Respuesta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma respuesta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma respuesta rápida disponível",
        buttons: {
          add: "Añadir",
          attach: "Anexar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com éxito!",
          deleted: "Atalho removido com éxito!",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atalho",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Añadir",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir vison",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nome do Archivo",
          status: "Estado",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Añadir",
          add: "Añadir",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        toasts: {
          deleted: "Registro eliminado",
          titles: {
            listCreated: "Lista Creada",
            contactsImported: "Contatos Importados",
            listRemoved: "Lista Removida",
          }
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Añadir",
          add: "Añadir",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no pode ser revertida.",
          importMessage: "Quieres importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        realTimeUpdates: "Atualizações em Tempo Real",
        addColumns: "Añadir colunas",
        loading: "Cargando...",
        save: "Guardar",
        saving: "Salvando...",
        cancel: "Cancelar",
        create: "Crear",
        createTask: "Crear Tarea",
        update: "Actualizar",
        close: "Cerrar",
        confirmDelete: "¿Estás seguro que quieres eliminar?",
        noLanes: "Nenhuma faixa disponível",
        showSubtasks: "Mostrar Subtarefas",
        hideSubtasks: "Ocultar Subtarefas",
        when: "Cuando",
        then: "Entonces",
        lastRun: "Última execução",
        neverRun: "Nunca executou",
        description: "Descripción",
        schedule: "Programación",
        cronHelp: "Use formato cron (ex: 0 9 * * 1-5 para todos os dias úteis às 9h)",
        fieldName: "Nome do Campo",
        fromValue: "Valor Anterior",
        toValue: "Valor Novo",
        targetTag: "Tag de Destino",
        userId: "ID do Usuario",
        notificationMessage: "Mensaje de Notificação",
        recipientId: "ID do Destinatário",
        newPriority: "Nova Prioridade",
        daysFromNow: "Dias a partir de hoje",
        daysFromNowHelp: "Número de dias para lañadir à data atual",
        tasks: {
          title: "Tareas",
          addTask: "Añadir Tarea",
          createTask: "Crear Tarea",
          editTask: "Editar Tarea",
          updateTask: "Actualizar Tarea",
          deleteTask: "Eliminar Tarea",
          taskDetails: "Detalhes da Tarea",
          taskProgress: "Progresso das Tareas",
          basicInfo: "Información Básicas",
          scheduling: "Programación",
          assignment: "Asignación",
          tags: "Etiquetas",
          description: "Descripción",
          priority: "Prioridad",
          status: "Estado",
          dueDate: "Data de Vencimento",
          estimatedHours: "Horas Estimadas",
          actualHours: "Horas Reais",
          assignTo: "Atribuir a",
          assignees: "Responsables",
          selectAssignees: "Selecionar Responsáveis",
          selectTags: "Selecionar Tags",
          titleRequired: "Título é obrigatório",
          startTimer: "Iniciar Timer",
          stopTimer: "Parar Timer",
          subtask: "Subtarea",
          createSubtask: "Crear Subtarefa",
          progress: "Progreso",
          completed: "Completado",
          inProgress: "Em Progresso",
          todo: "A Fazer",
          blocked: "Bloqueado",
          priority: {
            title: "Prioridad",
            low: "Baja",
            medium: "Media",
            high: "Alta",
            urgent: "Urgente",
          },
          status: {
            title: "Estado",
            todo: "A Fazer",
            in_progress: "Em Progresso",
            done: "Completado",
            blocked: "Bloqueado",
            open: "Em Atención",
            pending: "Pendiente",
            closed: "Cerrado",
          }
        },
        automation: {
          title: "Automatización",
          noAutomations: "Nenhuma automação configurada",
          getStarted: "Configure regras de automação para eltimizar seu fluxo de trabalho",
          description: "Configure regras de automação para eltimizar seu fluxo de trabalho",
          manage: "Gestionar Automações",
          createRule: "Crear Regra",
          editRule: "Editar Regra",
          ruleEngine: "Motor de Regras",
          triggers: "Desencadenadores",
          actions: "Acciones",
          conditions: "Condiciones",
          automation: "Automatización",
          automations: "Automatizaciones",
          ruleBuilder: "Construtor de Regras",
          confirmDelete: "¿Estás seguro que quieres eliminar esta automação?",
          when: "Cuando",
          then: "Entonces",
          lastRun: "Última execução",
          neverRun: "Nunca executou",
          basicInfo: "Información Básicas",
          ruleName: "Nome da Regra",
          description: "Descripción",
          activeRule: "Regra Activa",
          triggerType: "Tipo de Gatilho",
          actionType: "Tipo de Acción",
          preview: "Pré-visualização da Regra",
          conditionType: "Tipo de Condição",
          selectTrigger: "Selecionar Gatilho",
          fromTag: "Da Tag",
          toTag: "Para Tag",
          schedule: "Programación",
          cronHelp: "Use formato cron (ex: 0 9 * * 1-5 para todos os dias úteis às 9h)",
          fieldName: "Nome do Campo",
          fromValue: "Valor Anterior",
          toValue: "Valor Novo",
          targetTag: "Tag de Destino",
          userId: "ID do Usuario",
          notificationMessage: "Mensaje de Notificação",
          recipientId: "ID do Destinatário",
          newPriority: "Nova Prioridade",
          daysFromNow: "Dias a partir de hoje",
          daysFromNowHelp: "Número de dias para lañadir à data atual",
          triggerTypes: {
            ticket_moved: "Ticket Movido",
            task_completed: "Tarea Concluída",
            time_based: "Basado em Tempo",
            field_changed: "Campo Alterado",
            tag_assigned: "Tag Atribuída",
            user_assigned: "Usuario Atribuído",
          },
          actionTypes: {
            move_ticket: "Mover Ticket",
            assign_user: "Atribuir Usuario",
            send_notification: "Enviar Notificação",
            update_field: "Actualizar Campo",
            create_task: "Crear Tarea",
            change_priority: "Alterar Prioridade",
            set_due_date: "Definir Data de Vencimento",
          }
        },
        analytics: {
          title: "Análises",
          timeRange: "Período",
          last7Days: "Últimos 7 dias",
          last30Days: "Últimos 30 dias",
          last90Days: "Últimos 90 dias",
          totalTasks: "Total de Tareas",
          completedTasks: "Tareas Concluídas",
          completionRate: "Taxa de Conclusión",
          overdueTasks: "Tareas Atrasadas",
          remainingTasks: "Tareas Restantes",
          averageTime: "Tempo Medio",
          tasksByStatus: "Tareas por Status",
          tasksByPriority: "Tareas por Prioridade",
          burndownChart: "Gráfico de Burndown",
          teamPerformance: "Performance da Equipe",
          recentActivity: "Atividade Recente",
          tasksCompleted: "tareas concluídas",
          timeTracked: "tempo rastreado",
          noTeamData: "Nenhum dado da equipe disponível",
          recommendations: "Recomendaciones",
        },
        filters: {
          advancedFilters: "Filtros Avanzados",
          priority: "Prioridad",
          assignee: "Responsável",
          dueDate: "Data de Vencimento",
          taskStatus: "Status da Tarea",
          customFields: "Campos Personalizados",
          dateRange: "Intervalo de Datas",
          startDate: "Data de Início",
          endDate: "Data de Fim",
          search: "Buscar",
          sortBy: "Ordenar por",
          ticketNumber: "Número do Ticket",
          lastMessage: "Última Mensaje",
          valueDesc: "Valor (maior para menor)",
          quickFilters: "Filtros Rápidos",
          unassigned: "No Atribuídas",
          completed: "Concluídas",
          applyFilters: "Aplicar Filtros",
          clearFilters: "Limpar Filtros",
          activeFiltersCount: "{count} filtros ativos",
        },
        card: {
          viewTicket: "Ver Ticket",
          editValue: "Editar Valor",
          assignValue: "Atribuir Valor",
          value: "Valor",
          assignees: "Responsables",
          attachments: "Anexos",
          comments: "Comentários",
          progress: "Progreso",
          overdue: "Vencida",
          dueToday: "Vence Hoje",
          dueSoon: "Vence Em Breve",
        },
        bulk: {
          title: "Acciones em Lote",
          tasksSelected: "tareas selecionadas",
          selectedTasks: "Tareas Selecionadas",
          selectAll: "Selecionar Todas",
          deselectAll: "Desselecionar Todas",
          moreTasks: "mais tareas",
          selectAction: "Selecionar Acción",
          actionSettings: "Configuraciones da Acción",
          confirmAction: "Confirmar Acción",
          ejecute: "Executar",
          willAffect: "Esta acción afetará {count} tareas: {action}",
          confirmDangerous: "¿Estás seguro que quieres executar '{action}' em {count} tareas? Esta acción no pode ser desfeita.",
          bulkAssign: "Atribuir em Lote",
          assignDescription: "Atribuir todas as tareas selecionadas a um usuario",
          bulkMove: "Mover em Lote",
          moveDescription: "Mover todas as tareas selecionadas para uma tag",
          bulkPriority: "Definir Prioridade",
          priorityDescription: "Alterar a prioridade de todas as tareas selecionadas",
          bulkDueDate: "Definir Data de Vencimento",
          dueDateDescription: "Definir data de vencimento para todas as tareas selecionadas",
          bulkDelete: "Eliminar em Lote",
          deleteDescription: "Eliminar permanentemente todas as tareas selecionadas",
          selectUser: "Selecionar Usuario",
          selectTag: "Selecionar Tag",
        },
        column: {
          addTask: "Añadir Tarea",
          addTicket: "Añadir Ticket",
          settings: "Configuraciones da Coluna",
          colorChange: "Alterar Cor da Faixa",
          selectColor: "Selecionar Cor",
          itemCount: "item",
          itemsCount: "itens",
          totalValue: "Total",
        },
        lane: {
          addLane: "Añadir Coluna",
          enterTitle: "Digite o nome da coluna",
          add: "Añadir",
          cancel: "Cancelar",
          nameRequired: "Nome da coluna é obrigatório",
          created: "Coluna creada com éxito",
          colorUpdated: "Cor da coluna atualizada",
          createError: "Error ao crear coluna",
          updateColorError: "Error ao actualizar cor da coluna",
        },
        tabs: {
          board: "Quadro",
          analytics: "Análises",
          automations: "Automatizaciones",
        },
        messages: {
          errorFetchingUsers: "Error ao carregar usuarios",
          errorFetchingTags: "Error ao carregar tags",
          taskCreated: "Tarea creada com éxito",
          taskUpdated: "Tarea atualizada com éxito",
          taskDeleted: "Tarea eliminada com éxito",
          taskMoved: "Tarea movida com éxito",
          errorCreatingTask: "Error ao crear tarea",
          errorUpdatingTask: "Error ao actualizar tarea",
          errorDeletingTask: "Error ao eliminar tarea",
          errorMovingTask: "Error ao mover tarea",
          errorFetchingTasks: "Error ao carregar tareas",
          bulkUpdateSuccess: "Actualización em lote realizada com éxito",
          errorBulkUpdate: "Error na actualización em lote",
          progressUpdated: "Progresso actualizado",
          assignmentChanged: "Responsável alterado",
          errorAssigning: "Error ao atribuir tarea",
          errorUnassigning: "Error ao desatribuir tarea",
          errorUpdatingProgress: "Error ao actualizar progresso",
          taskMovedByUser: "Tarea movida por {user}",
          taskAssignedByUser: "Tarea atribuída por {user}",
          taskAssignedToYou: "Tarea '{title}' foi atribuída a você",
          automationTriggered: "Automação '{automation}' foi executada para tarea {task}",
          userEditingTask: "{user} está editando a tarea {task}",
          mentionedInComment: "Você foi mencionado em um comentário por {user} na tarea {task}",
          bulkOperationByUser: "{user} executou '{operation}' em {count} tareas",
          subtaskCreated: "Subtarefa creada com éxito",
          subtaskUpdated: "Subtarefa atualizada com éxito",
          subtaskDeleted: "Subtarefa eliminada com éxito",
          subtaskCompleted: "Subtarefa concluída",
          subtaskReopened: "Subtarefa reaberta",
          errorFetchingSubtasks: "Error ao carregar subtarefas",
          errorCreatingSubtask: "Error ao crear subtarefa",
          errorUpdatingSubtask: "Error ao actualizar subtarefa",
          errorDeletingSubtask: "Error ao eliminar subtarefa",
          errorTogglingSubtask: "Error ao alterar subtarefa",
          errorFetchingAutomations: "Error ao carregar automações",
          errorCreatingAutomation: "Error ao crear automação",
          errorUpdatingAutomation: "Error ao actualizar automação",
          errorDeletingAutomation: "Error ao eliminar automação",
          errorTogglingAutomation: "Error ao alternar automação",
          automationEnabled: "Automação ativada",
          automationDisabled: "Automação desativada",
          automationCreated: "Automação creada com éxito",
          automationUpdated: "Automação atualizada com éxito",
          automationDeleted: "Automação eliminada com éxito",
          automationTestSuccess: "Teste de automação bem-sucedido",
          errorTestingAutomation: "Error ao testar automação",
          errorFetchingAnalytics: "Error ao carregar análises",
          errorFetchingHistory: "Error ao carregar histórico",
          statusChanged: "Status da tarea '{title}' alterado para {status}",
          automationFailed: "Automação '{name}' falhou: {error}",
          milestoneReached: "Meta alcançada: {milestone} - {value}",
          deadlineApproaching: "{count} tareas com prazo se aproximando em {timeframe}",
          productivityAlert: "Alerta de produtividade: redução na taxa de conclusión detectada",
          overdueAlert: "Atenção: {count} tareas están atrasadas",
        },
        validation: {
          nameRequired: "Nome da regra é obrigatório",
          triggerRequired: "Tipo de gatilho é obrigatório",
          actionRequired: "Tipo de acción é obrigatório",
          cronRequired: "Agendamento cron é obrigatório",
          fieldRequired: "Nombre del campo é obrigatório",
          valueRequired: "Valor é obrigatório",
          targetRequired: "Tag de destino es obrigatória",
          userRequired: "Usuario é obrigatório",
          messageRequired: "Mensaje é obrigatória",
          recipientRequired: "Destinatário é obrigatório",
          daysRequired: "Número de dias é obrigatório",
        },
        recommendations: {
          improveTimeEstimation: "Melhore a precison das estimativas de tempo",
          addressOverdueTasks: "Trate as tareas em atraso com prioridade",
          improveThroughput: "Foque em melhorar o fluxo de conclusión de tareas",
        },
        laneConfig: {
          title: "Configurar Coluna",
          name: "Nome da Coluna",
          nameRequired: "Nome da coluna é obrigatório",
          color: "Cor da Coluna",
          preview: "Prévia",
          save: "Guardar",
          saving: "Salvando...",
          cancel: "Cancelar",
          updated: "Coluna atualizada com éxito",
          defaultLane: "Coluna Predeterminado",
          defaultLaneDescription: "Esta é a coluna padrão do sistema e no pode ser editada",
          cannotEditDefault: "A coluna padrão no pode ser modificada",
        },
        collaboration: {
          liveEditing: "Edição ao Vivo",
          userViewing: "{user} está visualizando",
          userEditing: "{user} está editando",
          conflictResolution: "Resolução de Conflitos",
          saveConflict: "Outro usuario fez alterações. Quieres mesclar ou sobrescrever?",
          merge: "Mesclar",
          overwrite: "Sobrescrever",
          reload: "Recargar",
        }
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Añadir variável",
          save: "Guardar",
          close: "Cerrar",
          add: "Añadir",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Acciones",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmação 1",
            confirmationMessage2: "Mensaje de Confirmação 2",
            confirmationMessage3: "Mensaje de Confirmação 3",
            confirmationMessage4: "Mensaje de Confirmação 4",
            confirmationMessage5: "Mensaje de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Etiquetas",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Añadir",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        toasts: {
          success: "Operación realizada com éxito",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro eliminado",
        },
        status: {
          scheduled: "Programada",
          running: "En Curso",
          finished: "Finalizada",
          cancelled: "Cancelada"
        },
        monitor: {
          title: "Monitor de Campaña",
          loading: "Cargando estadísticas...",
          noData: "No hay datos disponibles",
          refresh: "Actualizar",
          autoRefreshOn: "Auto-actualizar: Activado",
          autoRefreshOff: "Auto-actualizar: Desactivado",
          totalMessages: "Total de Mensajes",
          delivered: "Entregados",
          failed: "Fallidos",
          pending: "Pendientes",
          confirmed: "Confirmados",
          progress: "Progreso de la Campaña",
          successRate: "Tasa de Éxito",
          performance: "Rendimiento",
          queueWaiting: "Esperando en Cola",
          queueActive: "En Procesamiento",
          queueDelayed: "Programados",
          retryStats: "Estadísticas de Reintento",
          retrying: "Reintentando"
        }
      },
      campaignReport: {
        title: "Informe de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexión",
        contactLists: "Lista de Contatos",
        schedule: "Programación",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Title",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridad",
            title: "Title",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Añadir",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        toasts: {
          success: "Operación realizada com éxito",
          deleted: "Registro eliminado",
          titles: {
            cardCreated: "Card Creado",
            cardMoved: "Card Movido",
            kanbanError: "Error no Kanban",
          }
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nombre",
          color: "Cor",
          greeting: "Mensaje de saludo",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Añadir fila",
        },
        toasts: {
          success: "Fila salva com éxito",
          deleted: "Fila exclu[ida com éxito",
          titles: {
            queueCreated: "Fila Creada",
            queueUpdated: "Fila Atualizada",
            queueRemoved: "Fila Removida",
            queueError: "Error na Fila",
          }
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? Esta acción no se puede revertir! Os atenciones dessa fila continuarão existindo, mas no terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Colas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Informes de Atenciones",
        startDate: "Fecha Inicial",
        endDate: "Fecha final",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tempo de Atención",
          tags: "Etiquetas",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Buscar...",
        exportExcel: {
          title: "Informes de Atenciones",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Cola",
            status: "Estado",
            lastMessage: "Última Mensaje",
            openDate: "Fecha de Apertura",
            openTime: "Hora de Apertura",
            closeDate: "Fecha de Cierre",
            closeTime: "Hora de Cierre",
            supportTime: "Tempo de Atención",
            nps: "NPS",
            valorVenda: "Valor da Venda",
            motivoNaoVenda: "Motivo da No Venda",
            finalizadoComVenda: "Finalizado com Venda",
            tags: "Etiquetas",
          },
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Añadir Projeto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? Esta acción no se puede revertir! e se removida das filas e conexiones vinculadas",
        },
        toasts: {
          titles: {
            integrationSaved: "Integración Salva",
            integrationError: "Error na Integración",
            integrationRemoved: "Integración Removida",
            webhookConfigured: "Webhook Configurado",
          }
        },
      },
      flowBuilder: {
        title: "Construtor de Fluxo",
        toasts: {
          titles: {
            flowSaved: "Fluxo Guardado",
            nodeAdded: "Nó Adicionado",
            flowError: "Error no Fluxo",
            flowRemoved: "Fluxo Removido",
            requestTested: "Requisição Probada",
            requestError: "Error na Requisição",
            connectionEstablished: "Conexión Estabelecida",
            flowCreated: "Fluxo Creado",
            flowUpdated: "Fluxo Actualizado",
            mediaAttached: "Mídia Anexada",
            nodeError: "Error no Nó",
            menuCreated: "Menu Creado",
            optionsSaved: "Opciones Salvas",
            menuError: "Error no Menu",
            conditionCreated: "Condição Creada",
            ruleAdded: "Regra Agregada",
            conditionError: "Error na Condição",
            intervalDefined: "Intervalo Definido",
            timerConfigured: "Timer Configurado",
            intervalError: "Error no Intervalo",
            randomizationConfigured: "Randomização Configurada",
            drawCreated: "Sorteio Creado",
            randomizerError: "Error no Randomizador",
            tagRemoved: "Tag Removida",
            filterApplied: "Filtro Aplicado",
            removalError: "Error na Remoção",
          }
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Añadir usuario",
        },
        toasts: {
          deleted: "Usuario eliminado com éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos os datos do usuario se perdidos. Os atención abertos deste usuario se movidos para la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plano",
          active: "Activo",
          numberAttendants: "Atendentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Colas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programación",
          createdAt: "Creada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de archivos",
          lastUpdate: "Ultimo update",
          actions: "Acciones",
          viewDetails: "Clique para ver detalhes completos",
          money: "$",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Añadir empresa",
        },
        toasts: {
          deleted: "Empresa eliminado com éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos os datos da empresa se perdidos. Os tickets abertos deste usuario se movidos para la fila.",
        },
      },
      plans: {
        title: "Gestionar Planos",
        subtitle: "Configure e gerencie os planos disponíveis para sua empresa",
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
          whatsappCatalog: "Catálogo WhatsApp"
        },
        cards: {
          edit: "Editar Plano",
          featured: "Destaque",
          popular: "Popular",
          trial: "Trial Grátis",
          perMonth: "/mês",
          features: "Recursos Incluídos",
          limits: "Limites do Plano",
          channels: "Canais de Comunicação",
          integrations: "Integraciones",
          advanced: "Recursos Avanzados",
          userLimit: "usuarios",
          connectionLimit: "conexiones",
          queueLimit: "filas",
          trialDaysLabel: "dias de teste",
          publicPlan: "Plano Público",
          privatePlan: "Plano Privado",
          whatsapp: "WhatsApp",
          whatsappOfficial: "WhatsApp Oficial",
          facebook: "Facebook",
          instagram: "Instagram",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "Kanban",
          openai: "Talk.Ai",
          groups: "Grupos",
          landingPages: "Landing Pages",
          webChat: "WebChat",
          assistants: "Asistentes",
          noPlans: "Nenhum plano encontrado",
          createFirst: "Crie seu primeiro plano usando o formulario acima",
        }
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descripción",
          clear: "Limpar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "No há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "¿Estás seguro que quer eliminar este Agendamento?",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento eliminado com éxito.",
          titles: {
            scheduleSaved: "Agendamento Guardado",
            timeSet: "Horário Definido",
            scheduleError: "Error no Agendamento",
            scheduleRemoved: "Agendamento Removido",
          }
        },
      },
      tags: {
        title: "Etiquetas",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "¿Estás seguro que quer eliminar esta Tag?",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag eliminado com éxito.",
          titles: {
            tagCreated: "Tag Creada",
            tagRemoved: "Tag Removida",
            tagError: "Error na Tag",
          }
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em abierto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "¿Estás seguro que quer eliminar esta Lane?",
          deleteMessage: "Esta acción no pode ser revertida.",
        },
        table: {
          name: "Nombre",
          color: "Cor",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane eliminada com éxito.",
        },
      },

      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Lista eliminada com éxito!",
          deletedAll: "Todas as listas foram excluídas com éxito!",
        },
        buttons: {
          add: "Añadir",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro que quieres eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro que quieres eliminar todas as listas?",
        },
      },
      messagesList: {
        toasts: {
          messageSent: "Mensaje Enviada",
          loadingError: "Error no Carregamento",
          fileDownloaded: "Archivo Baixado",
          mediaError: "Error de Mídia",
          connectionError: "Error de Conexión",
        },
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Quieres deixar uma evaluación de atención para el cliente?",
          dialogClosingTitle: "Finalizando o atención com o cliente!",
          dialogRatingCancel: "Resolver COM Mensaje de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensaje de Despedida",
          ratingTitle: "Escolha um menu de evaluación",
          notMessage: "Nenhuma mensaje selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar integración",
            disableIntegration: "Desabilitar integración",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de cerrar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensaje de saludo ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensaje ou aperte / para respuestas rápidas",
        placeholderOpen:
          "Digite uma mensaje ou aperte / para respuestas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensaje.",
        signMessage: "Assinar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Datos do contato",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras información",
        groupUsers: "Usuarios do Grupo",
        groupWithUsers: "Para que as mensajes de grupo funcione como ticket e entre em esperando, é necesario remover todos os membros desta lista de usuarios.",
        groupWithoutUsers: "Ao añadir membros, as mensajes de atención entrarão diretamente na aba atendendo e todos os usuarios seleccionados se notificados.",
        saveUsers: "Guardar Usuarios",
        saving: "Salvando...",
        usersUpdatedSuccess: "Usuarios do grupo atualizados com éxito!",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nombre",
          user: "Atendente",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observaciones do Ticket",
          textarea: "Observación",
          placeholder: "Insira aqui a información que quieres registrar",
        },
        confirmationModal: {
          title: "Eliminar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensajes relacionadas ao ticket se perdidas.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensaje Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contacto",
          meet: "Vídeo chamada",
          template: "Template Meta",
          aiSuggestion: "Sugerencias de IA",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Conversar Com",
        addReaction: "Añadir reação",
        removeReaction: "Remover reação",
        reactions: {
          addReaction: "Añadir reação",
          removeReaction: "Remover reação",
          reactionsCount: "reação(ões)",
        },
        confirmationModal: {
          title: "Apagar mensaje?",
          message: "Esta acción no pode ser revertida.",
        },
      },
      timeMonitoring: {
        title: "Monitoreo de Tempo de Respuesta",
        enabled: "Monitoreo Activado",
        responseTimeLimit: "Limite de Tempo de Respuesta (minutos)",
        timeoutAction: "Acción ao Atingir Timeout",
        timeoutActions: {
          user: "Transferir para usuario específico",
          queue: "Transferir para fila específica",
        },
        targetUser: "Usuario de destino",
        targetQueue: "Fila de destino",
        warning: {
          enabled: "Avisos antes do timeout",
          minutes: "Minutos antes do aviso",
        },
        timer: {
          title: "Tempo de Respuesta",
          timeRemaining: "restantes",
          timeLimit: "Limite",
          minutes: "min",
          status: {
            warning: "ATENÇÃO",
            timeout: "TIMEOUT",
          },
          minimizeTimer: "Minimizar cronômetro",
          warning: "Advertencia",
        }
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Acción",
        },
      },
      timeMonitoring: {
        title: "Monitoreo de Tiempo de Respuesta",
        description: "Configurar monitoreo de tiempo de respuesta y límites de tickets por usuario",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        updating: "Actualizando...",
        loading: "Cargando configuraciones...",
        save: "Guardar",
        saving: "Guardando...",
        reset: "Restablecer",
        basicSettings: "Configuraciones Básicas",
        enableMonitoring: "Habilitar monitoreo de tiempo",
        enableMonitoringDesc: "Activar monitoreo automático de tiempo de respuesta de los atendimientos",
        responseTimeLimit: "Tiempo límite (minutos)",
        responseTimeLimitDesc: "Define el tiempo máximo de respuesta antes de activar acciones automáticas",
        responseLimitHelper: "Tiempo máximo para respuesta antes de la acción automática (entre 1-480 minutos)",
        monitoringScope: "Alcance del monitoreo",
        monitoringScopeDesc: "Defina si el monitoreo se aplicará por empresa o por cola/conexión",
        scopeCompany: "Por empresa",
        scopeQueue: "Por cola/conexión",
        warningSettings: "Configuraciones de Aviso",
        enableWarning: "Enviar aviso antes del timeout",
        enableWarningDesc: "Activar alertas visuales antes de que se alcance el límite de tiempo",
        warningMinutes: "Minutos antes del timeout para aviso",
        warningMinutesDesc: "Tiempo de anticipación para mostrar avisos antes del timeout",
        warningMinutesHelper: "Los avisos se mostrarán X minutos antes del timeout (entre 1-60 minutos)",
        timeoutAction: "Acción en Timeout",
        timeoutActionLabel: "Acción cuando alcance tiempo límite",
        timeoutActionDesc: "Seleccione la acción automática a ejecutar cuando se exceda el límite de tiempo",
        transferToUser: "Transferir a usuario específico",
        transferToQueue: "Transferir a cola específica",
        targetUser: "Usuario de destino",
        targetUserDesc: "Seleccione el usuario que recibirá los tickets transferidos por timeout",
        selectUser: "Seleccione un usuario",
        targetQueue: "Cola de destino",
        targetQueueDesc: "Seleccione la cola que recibirá los tickets transferidos por timeout",
        selectQueue: "Seleccione una cola",
        statistics: "Estadísticas",
        currentStats: "Estadísticas Actuales",
        activeTickets: "Tickets Activos",
        avgResponseTime: "Tiempo Promedio de Respuesta",
        timeouts: "Timeouts",
        successRate: "Tasa de Éxito",
        ticketLimits: "Límite de Tickets por Usuario",
        enableTicketLimits: "Habilitar límite de tickets activos",
        maxActiveTickets: "Máximo de tickets activos por usuario",
        allowMultipleTickets: "Permitir aceptar múltiples tickets",
        buttons: {
          save: "Guardar Configuraciones",
          saving: "Guardando...",
          cancel: "Cancelar"
        },
        messages: {
          saveTitle: "Configuraciones Guardadas",
          saveSuccess: "¡Configuraciones guardadas con éxito!",
          loadError: "Error al cargar configuraciones de monitoreo de tiempo",
          saveError: "Error al guardar configuraciones",
          ticketLimitReached: "No es posible aceptar más tickets",
          ticketLimitWarning: "Límite de tickets activos alcanzado"
        },
        errors: {
          title: "Error",
          loadData: "Error al cargar datos auxiliares"
        },
        userStatus: {
          title: "Estado Actual",
          activeTickets: "Tickets activos",
          limitReached: "Límite de tickets activos alcanzado"
        },
        timer: {
          title: "Tiempo de Respuesta",
          timeRemaining: "restantes",
          timeLimit: "Límite",
          timeElapsed: "¡Tiempo agotado!",
          warning: "Aviso",
          minimizeTimer: "Minimizar temporizador",
            warning: "{minutes}min restantes",
            normal: "{minutes}min restantes",
          }
        },
        dashboard: {
          userActivity: {
            title: "Status dos Usuarios",
            active: "Ativos",
            inactive: "Inativos",
            offline: "Offline",
            tickets: "Tickets",
            showDetails: "Ver Detalhes",
            hideDetails: "Ocultar Detalhes",
            inactiveFor: "Inactivo há",
            userStatus: {
              active: "Activo",
              inactive: "Inactivo",
              offline: "Offline",
            }
          }
        }
      },

      settings: {
        success: "Configuraciones salvas com éxito.",
        title: "Configuraciones",
        tabs: {
          ia: "IA",
          options: "Opciones",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
          webchat: "WebChat",
          fiscal: "Configuración Fiscal",
          schedules: "Horários",
        },
        apollo: {
          sectionTitle: "Configuración Apollo.io para IA SDR",
          sectionDescription: "Configure o Apollo.io para descoberta automática de leads e enriquecimento. Necesario para recursos de IA SDR.",
          apiKey: "Chave API Apollo.io",
          apiKeyDescription: "Sua chave API do Apollo.io para descoberta e enriquecimento de leads",
          enableIntegration: "Habilitar Integración Apollo.io",
          enableDescription: "Habilitar Apollo.io para recursos de descoberta e enriquecimento de leads",
          monthlySearchLimit: "Limite Mensal de Buscas",
          monthlySearchDescription: "Número máximo de buscas permitidas por mês",
          monthlyEnrichmentLimit: "Limite Mensal de Enriquecimentos",
          monthlyEnrichmentDescription: "Número máximo de enriquecimentos permitidos por mês",
          defaultLocation: "Localización Predeterminado",
          defaultLocationDescription: "Localización padrão para busca de leads (ex: Brazil, United States)",
        },
        settings: {
          ia: {
            globalAiConfigTitle: "Configuración Global de IA",
            globalAiConfigDesc: "Configure as definições globais de inteligência artificial para toda a empresa. Estas configuraciones se aplicadas a todos os assistentes que no possuam configuración específica.",
            openAiApiKey: "Chave da API OpenAI",
            openAiApiKeyDesc: "Insira sua chave de API da OpenAI para habilitar recursos de IA",
            apiKeyRequired: "Chave da API é obrigatória",
            invalidApiKeyFormat: "Formato inválido da chave API. Deve começar com 'sk-'",
            apiKeyValidatedSuccess: "Chave da API validada com éxito! {models} modelos disponíveis.",
            apiKeyValidationError: "Error ao validar a chave da API",
            invalidApiKey: "Chave da API inválida",
            rateLimitExceeded: "Limite de taxa excedido. Tente novamente mais tarde.",
            accessDenied: "Acesso negado. Verifique suas permisos.",
            networkError: "Error de rede. Verifique tu conexión.",
            internalError: "Error interno do servidor",
            networkConnectionError: "Error de conexión de rede",
            validatingApiKey: "Validando chave da API",
            validKeySuccess: "Chave válida",
            modelsAvailable: "modelos disponíveis",
            validating: "Validando",
            validateKey: "Validar Chave",
            getApiKey: "Obter chave da API",
            defaultOpenAiModel: "Modelo OpenAI Predeterminado",
            defaultOpenAiModelDesc: "Modelo que se usado por padrão para gerar respuestas",
            aiProvider: "Provedor de IA",
            aiProviderDesc: "Provedor de inteligência artificial a ser utilizado",
            autoShowSuggestions: "Sugerencias Automáticas",
            autoShowSuggestionsDesc: "Exibir sugerencias de respuesta automáticamente durante as conversaciónções",
            enableAudioTranscription: "Transcripción de Áudio",
            enableAudioTranscriptionDesc: "Habilitar transcrição automática de mensajes de voz",
            transcriptionModel: "Modelo de Transcripción",
            transcriptionModelDesc: "Modelo usado para transcrição de áudio",
            defaultTranscriptionLanguage: "Idioma Predeterminado",
            defaultTranscriptionLanguageDesc: "Idioma usado por padrão para transcrição",
            portuguese: "Português",
            english: "Inglês",
            spanish: "Espanhol",
            french: "Francês",
            german: "Alemão",
            italian: "Italiano",
            japanese: "Japonês",
            korean: "Coreano",
            chinese: "Chinês",
            autoDetect: "Detecção Automática",
            enableVoiceResponses: "Respuestas por Voz",
            enableVoiceResponsesDesc: "Gerar respuestas em áudio usando síntese de voz",
            defaultVoice: "Voz Predeterminado",
            defaultVoiceDesc: "Voz utilizada para gerar respuestas em áudio",
            speechSpeed: "Velocidade da Fala",
            speechSpeedDesc: "Velocidade de reprodução das respuestas em voz",
            enableGroupResume: "Resumo de Grupos",
            enableGroupResumeDesc: "Habilitar generación de resumos de conversaciones em grupos",
            summaryDefaultLanguage: "Idioma del Resumen",
            summaryDefaultLanguageDesc: "Idioma padrão para gerar resumos",
            summaryDefaultLength: "Tamaño del Resumen",
            summaryDefaultLengthDesc: "Tamanho padrão dos resumos gerados",
            includeParticipantStatsDefault: "Estatísticas de Participantes",
            includeParticipantStatsDefaultDesc: "Incluir estatísticas de participação nos resumos por padrão",
            defaultCreativity: "Criatividade Predeterminado",
            defaultCreativityDesc: "Nível de criatividade das respuestas (temperatura)",
            conservative: "Conservador",
            balanced: "Equilibrado",
            creative: "Criativo",
            defaultMaxTokens: "Máximo de Tokens",
            defaultMaxTokensDesc: "Número máximo de tokens para respuestas",
            configurationTipsTitle: "Dicas de Configuración",
            centralizedConfiguration: "Configuración Centralizada",
            centralizedConfigurationDesc: "Essas configuraciones son aplicadas globalmente em toda a empresa",
            openAiKey: "Chave OpenAI",
            openAiKeyDesc: "Obtenha sua chave em platform.openai.com/api-keys",
            recommendedModels: "Modelos Recomendados",
            recommendedModelsDesc: "GPT-4o para melhor qualidade, GPT-4o Mini para economia",
            voice: "Voz",
            voiceDesc: "Nova e Alloy son as vozes mais naturais",
            performance: "Performance",
            performanceDesc: "Menor temperatura = respuestas mais consistentes",
            aiConfigurationActive: "Configuración de IA Activa",
            currentAiSettings: "Configuraciones atuais: Modelo {model}, Transcripción {transcription}, Voz {voice}, Sugerencias {suggestions}",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            aiNotConfiguredTitle: "IA No Configurada",
            aiNotConfiguredDesc: "Configure uma chave da API OpenAI para habilitar recursos de inteligência artificial",
            copied: "Copiado",
            copyCode: "Copiar código QR PIX",
            short: "Corto",
            medium: "Medio",
            long: "Largo",
            portugueseBrazil: "Português (Brasil)",
            englishUS: "English (US)",
            spanishES: "Español",
          },
          options: {
            title: "Configuraciones do Sistema",
            description: "Configure as opciones gerais de funcionamiento do sistema",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
            updating: "Atualizando...",
            secure: "Seguro",
            generalSettings: "Configuraciones Gerais",
            paymentSettings: "Configuraciones de Pagamento",
            lgpdSettings: "Configuraciones LGPD",
            formattingSettings: "Configuraciones de Formatação",
            customMessages: "Mensajes Personalizadas",

            // Configuraciones Gerais
            creationCompanyUser: "Creación de usuario da empresa",
            creationCompanyUserDesc: "Permitir que usuarios da empresa criem outros usuarios",
            evaluations: "Evaluaciones",
            evaluationsDesc: "Sistema de evaluación de atención pelos clientes",
            officeScheduling: "Agendamento por horários de funcionamiento",
            officeSchedulingDesc: "Controlar agendamentos basado no horário de funcionamiento",
            sendGreetingAccepted: "Envio de saludo de aceite",
            sendGreetingAcceptedDesc: "Enviar mensaje automática quando aceitar um atención",
            userRandom: "Usuario aleatório",
            userRandomDesc: "Distribuir atenciones aleatoriamente entre usuarios disponíveis",
            acceptCallWhatsapp: "Aceitar chamadas no WhatsApp",
            acceptCallWhatsappDesc: "Permitir recebimento de chamadas telefônicas pelo WhatsApp",
            sendSignMessage: "Envio de mensaje de assinatura",
            sendSignMessageDesc: "Enviar mensaje de assinatura no final do atención",
            sendGreetingMessageOneQueues: "Envio de saludo em filas únicas",
            sendGreetingMessageOneQueuesDesc: "Enviar mensaje de saludo quando há apenas uma fila",
            sendQueuePosition: "Envio de posição na fila",
            sendQueuePositionDesc: "Informar posição do cliente na fila de atención",
            sendFarewellWaitingTicket: "Envio de despedida em espera",
            sendFarewellWaitingTicketDesc: "Enviar mensaje de despedida quando ticket fica em espera",
            acceptAudioMessageContact: "Aceitar mensajes de áudio de contatos",
            acceptAudioMessageContactDesc: "Permitir recebimento de mensajes de áudio de contatos",
            settingsTransfTicket: "Configuraciones de transferência de ticket",
            settingsTransfTicketDesc: "Habilitar configuraciones avanzadas para transferência de tickets",
            chatBotType: "Tipo de chatbot",
            chatBotTypeDesc: "Configurar tipo de respuesta do chatbot (texto ou voz)",
            informarValorVenda: "Finalización con valor de venta",
            informarValorVendaDesc: "Habilitar información de valor de venta al finalizar atención",

            // Opciones de sistema
            queueManagement: "Gerenciamento por filas",
            companyManagement: "Gerenciamento por empresa",
            connectionManagement: "Gerenciamento por conexión",
            textOnly: "Apenas texto",
            voiceAndText: "Voz e texto",

            // Configuraciones de Pagamento
            efiClientId: "EFI Client ID",
            efiClientIdDesc: "ID do cliente para integración com EFI Pay",
            efiClientSecret: "EFI Client Secret",
            efiClientSecretDesc: "Chave secreta para integración com EFI Pay",
            mpAccessToken: "Mercado Pago Access Token",
            mpAccessTokenDesc: "Token de acesso para integración com Mercado Pago",
            asaasToken: "Asaas Token",
            asaasTokenDesc: "Token de acesso para integración com Asaas",

            // Configuraciones LGPD
            enableLGPD: "Habilitar LGPD",
            enableLGPDDesc: "Activar conformidade com a Lei Geral de Proteção de Datos",
            lgpdMessage: "Mensaje LGPD",
            lgpdMessageDesc: "Mensaje de consentimento LGPD enviada aos usuarios",
            lgpdLink: "Link da Política de Privacidade",
            lgpdLinkDesc: "URL da política de privacidade da empresa",

            // Configuraciones de Formatação
            systemCurrency: "Moeda do Sistema",
            systemCurrencyDesc: "Moeda padrão utilizada no sistema",
            systemDateFormat: "Formato de Data",
            systemDateFormatDesc: "Formato de exibição de datas no sistema",

            // Configuraciones de Sistema
            systemSettings: "Configurações do Sistema",
            requiredTag: "Tag obrigatória",
            requiredTagDesc: "Exigir selección de tag para finalizar atenciones",
            closeTicketOnTransfer: "Cerrar ticket ao transferir",
            closeTicketOnTransferDesc: "Cerrar automáticamente o ticket ao transferir para elutro setor",
            directTicketsToWallets: "Direcionar tickets para carteiras",
            directTicketsToWalletsDesc: "Usar sistema de carteiras de clientes para distribuição de tickets",
            copyContactPrefix: "Prefixo para cópia de contatos",
            copyContactPrefixDesc: "Sigla agregada ao copiar información de contatos",
            showNotificationPending: "Notificación de tickets pendientes",
            showNotificationPendingDesc: "Mostrar notificaciones para tickets en estado pendiente",
            alwaysSelectQueueOnAccept: "Siempre seleccionar cola al aceptar ticket",
            alwaysSelectQueueOnAcceptDesc: "Cuando está habilitado, siempre requerirá selección de cola al aceptar tickets, incluso si ya tiene una cola asignada",
            openAiToken: "Token OpenAI",
            openAiTokenDesc: "Token de acesso para integración com OpenAI para transcrição de áudio",
            // Mensajes Personalizadas
            transferMessage: "Mensaje de Transferencia",
            transferMessageDesc: "Mensaje enviado cuando una atención es transferida",
            greetingAcceptedMessage: "Mensaje de Aceptación",
            greetingAcceptedMessageDesc: "Mensaje enviado cuando una atención es aceptada",
            greetingMessageOneQueuesMessage: "Mensaje de Saludo (Cola Única)",
            greetingMessageOneQueuesMessageDesc: "Mensaje enviado automáticamente cuando hay solo una cola disponible",
            acceptCallWhatsappMessage: "Mensaje de Aviso sobre Llamadas",
            acceptCallWhatsappMessageDesc: "Mensaje informativo sobre llamadas telefónicas en WhatsApp",
            sendQueuePositionMessage: "Mensaje de Posición en la Cola",
            sendQueuePositionMessageDesc: "Mensaje informando la posición del cliente en la cola de atención",
            success: "Éxito",
            error: "Error",
            updateSuccess: "¡Configuración actualizada con éxito!",
            updateError: "Error al actualizar configuración. Intente nuevamente.",
            currencyUpdateSuccess: "¡Moneda actualizada con éxito!",
            dateFormatUpdateSuccess: "¡Formato de fecha actualizado con éxito!",
            efiChavePix: "Clave PIX EFI",
            efiChavePixDesc: "Clave PIX registrada en la cuenta EFI Pay",
            stripePrivateKey: "Clave Privada Stripe",
            stripePrivateKeyDesc: "Clave privada para integración con Stripe",
            lgpdDeleteMessage: "Eliminar mensaje después del consentimiento",
            lgpdDeleteMessageDesc: "Borrar mensaje del cliente después de aceptar LGPD",
            lgpdConsent: "Requerir consentimiento LGPD",
            lgpdConsentDesc: "Solicitar consentimiento explícito del cliente para LGPD",
            lgpdHideNumber: "Ocultar número de contacto",
            lgpdHideNumberDesc: "Ocultar números de teléfono para cumplimiento con LGPD"
          },
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la cola",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            greetingMessageOneQueuesMessage: "Mensaje de Saludo (Cola Única)",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola destino",
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Creación de Company/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexión",
            sendGreetingAccepted: "Enviar saludo ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensaje transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que no aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saludo quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensaje com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida no Esperando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para cerrar ticket",
            closeTicketOnTransfer:
              "Cerrar ticket ao transferir para elutra fila",
            DirectTicketsToWallets:
              "Mover automáticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensaje apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
          formatting: {
            systemCurrency: "Moeda do Sistema",
            systemCurrencyHelp: "Define a moeda utilizada em todo o sistema",
            systemDateFormat: "Formato de Data",
            systemDateFormatHelp: "Define como as datas son exibidas no sistema",
            updating: "Atualizando...",
            currencyUpdatedSuccess: "Moeda atualizada com éxito!",
            currencyUpdateError: "Error ao actualizar moeda",
            dateFormatUpdatedSuccess: "Formato de data actualizado com éxito!",
            dateFormatUpdateError: "Error ao actualizar formato de data",
          },
        },
        webchat: {
          title: "Configuración de WebChat",
          tabs: {
            appearance: "Apariencia",
            behavior: "Comportamiento",
            files: "Archivos",
            code: "Código",
            customization: "Personalización",
          },
          form: {
            enabled: "WebChat Habilitado",
            widgetColor: "Color del Widget",
            widgetPosition: "Posición",
            widgetTitle: "Título del Widget",
            widgetDescription: "Descripción",
            welcomeMessage: "Mensaje de Bienvenida",
            messagePlaceholder: "Marcador de Posición del Mensaje",
            customCSS: "CSS Personalizado",
            autoAssign: "Asignación Automática de Agentes",
            queueId: "Cola Predeterminada",
            respectBusinessHours: "Respetar Horario Comercial",
            maxConcurrentChats: "Máximo de Chats Simultáneos",
            offlineMessage: "Mensaje Fuera de Horario",
            showAgentInfo: "Mostrar Información del Agente",
            allowFileUpload: "Permitir Carga de Archivos",
            allowedFileTypes: "Tipos de Archivo Permitidos",
            maxFileSize: "Tamaño Máximo (MB)",
            requireName: "Nombre Obligatorio",
            requireEmail: "Email Obligatorio",
            requirePhone: "Teléfono Obligatorio",
            enableAssistant: "Habilitar Asistente de IA",
            assistantId: "Asistente de IA",
            companyName: "Nombre de la Empresa",
            companyUrl: "URL de la Empresa",
            companyLogoUrl: "URL del Logo de la Empresa"
          },
          positions: {
            right: "Derecha",
            left: "Izquierda",
          },
          placeholders: {
            widgetColor: "#2563eb",
            widgetTitle: "Atención",
            widgetDescription: "¡Estamos aquí para ayudar!",
            welcomeMessage: "¡Hola! ¿En qué puedo ayudarte?",
            messagePlaceholder: "Escribe tu mensaje...",
            offlineMessage: "Nuestro horario de atención es de lunes a viernes, de 8am a 6pm.",
            allowedFileTypes: "jpg,jpeg,png,pdf,doc,docx",
            customCSS: "/* Agrega tus estilos CSS personalizados aquí */",
          },
          help: {
            allowedFileTypes: "Separe por coma (ej: jpg,png,pdf)",
            customCSS: "CSS personalizado para estilizar el widget",
            maxFileSize: "Tamaño máximo en MB",
            noAssistants: "No se encontraron asistentes activos. Configure asistentes en Configuración → IA."
          },
          validation: {
            required: "Obligatorio",
            colorFormat: "El color debe estar en formato hexadecimal",
            maxLength: "Máximo {max} caracteres",
            maxValue: "Máximo {max}",
            positive: "El valor debe ser positivo",
            assistantRequired: "Seleccione un asistente cuando el servicio de IA esté activado"
          },
          messages: {
            success: "¡Configuración guardada con éxito!",
            codeCopied: "¡Código copiado al portapapeles!",
            noQueue: "Sin cola específica",
            loadingAssistants: "Cargando asistentes...",
            selectAssistant: "Seleccione un asistente"
          },
          code: {
            title: "Código de Integración",
            description: "Copie y pegue este código en su sitio web donde desea que aparezca el widget:",
            copyButton: "Copiar Código",
            manualInit: "O inicializar manualmente",
          },
          buttons: {
            save: "Guardar Configuración",
            cancel: "Cancelar",
          },
          requiredFields: "Campos Obligatorios",
          preview: {
            poweredBy: "Desarrollado por"
          }
        },
        webChat: {
          list: {
            title: "WebChats",
            newWebChat: "Nuevo WebChat",
            name: "Nombre",
            status: "Estado",
            token: "Token",
            allowedOrigins: "Orígenes Permitidos",
            actions: "Acciones",
            enabled: "Activo",
            disabled: "Inactivo",
            copyToken: "Copiar Token",
            copyCode: "Copiar Código",
            edit: "Editar",
            delete: "Eliminar",
            tokenCopied: "¡Token copiado!",
            codeCopied: "¡Código copiado!",
            loading: "Cargando...",
            noWebChats: "No hay WebChats creados",
            allOrigins: "Todos",
            deleteConfirmTitle: "Eliminar WebChat",
            deleteConfirmMessage: "¿Está seguro de que desea eliminar el WebChat '{name}'?",
            deleteSuccess: "¡WebChat eliminado con éxito!"
          },
          form: {
            createTitle: "Crear WebChat",
            editTitle: "Editar WebChat",
            name: "Nombre del WebChat",
            namePlaceholder: "Ej: Sitio Principal, Landing Page, Blog",
            allowedOrigins: "Orígenes Permitidos",
            allowedOriginsPlaceholder: "https://tusitio.com\nhttps://www.tusitio.com\n*.tusitio.com",
            allowedOriginsHelp: "Una URL por línea. Use * para subdominios. Deje vacío para permitir todos."
          },
          validation: {
            nameRequired: "El nombre es obligatorio",
            invalidOrigins: "Uno o más orígenes tienen formato inválido. Use http://, https:// o *."
          },
          messages: {
            createSuccess: "¡WebChat creado con éxito!",
            updateSuccess: "¡WebChat actualizado con éxito!",
            created: "Creado",
            updated: "Actualizado",
            codeCopied: "¡Código copiado!",
            saveToGetCode: "Guarde el WebChat para obtener el código de integración"
          }
        },
      },
      landingPages: {
        title: "Landing Pages",
        newLandingPage: "Nova Landing Page",
        searchPlaceholder: "Buscar landing pages...",
        createNewLandingPage: "Crear nova Landing Page",
        status: "Estado",
        all: "Todas",
        active: "Ativas",
        inactive: "Inativas",
        viewAsGrid: "Visualizar em grade",
        viewAsList: "Visualizar em lista",
        noLandingPagesFound: "Nenhuma landing page encontrada",
        noLandingPagesCreated: "Nenhuma landing page creada",
        adjustSearch: "Tente ajustar sua búsqueda",
        createFirstLandingPage: "Crie sua primeira landing page para divulgar seu negócio ou coletar leads.",

        // Editor
        editor: {
          loading: "Cargando...",
          editing: "Editando Landing Page",
          saving: "Salvando...",
          published: "Publicada",
          back: "Volver",
          preview: "Visualizar",
          save: "Guardar",
          close: "Cerrar",
          previewTitle: "Pré-visualização",
          invalidId: "ID da landing page inválido",
          titleRequired: "O título da página é obrigatório",
          saveSuccess: "Landing page creada com éxito!",
          updateSuccess: "Landing page atualizada com éxito!",
          saveError: "Error ao guardar: {message}",
          loadError: "Error ao carregar landing page: {message}",
          draftModeAlert: "Esta landing page está em modo rascunho. Ative-a na aba 'Configuraciones'.",
          saveReminderAlert: "Lembre-se de guardar suas alterações antes de sair da página.",
          defaultContent: "Digite o conteúdo da sua landing page aqui...",
          defaultFormTitle: "Formulario de Registro",
          defaultButtonText: "Enviar",
          defaultFormDescription: "Formulario para coleta de leads",
          defaultMessageTemplate: "Olá! Uma nova inscrição foi realizada na landing page {landing_page}:\\n\\nNome: {name}\\nE-mail: {email}\\nData: {date}",
          defaultConfirmationMessage: "Obligatorio por se registrar! Seu formulario foi recebido com éxito.",
          defaultWhatsAppMessage: "Olá! Gostaria de saber mais sobre {landing_page}",
        },

        // Tabs
        tabs: {
          basic: "Básico",
          content: "Conteúdo",
          form: "Formulario",
          appearance: "Aparência",
          notifications: "Notificações",
          affiliates: "Afiliados",
          advanced: "Avanzado",
        },

        // Basic tab
        basic: {
          title: "Información Básicas",
          loadQueuesError: "Error ao carregar filas",
          pageTitle: "Título da Página",
          pageTitlePlaceholder: "Ex: Webinar de Marketing Digital",
          pageTitleHelperText: "O título se exibido na aba do navegador e em compartilhamentos",
          pageSlug: "URL da Página (Slug)",
          slugTaken: "Esta URL já está em uso. Por favor, escolha outra.",
          slugHelperText: "A URL amigável que se usada para lacessar sua página",
          autoGenerateSlug: "Gerar URL automáticamente a partir do título",
          fullUrl: "URL completa da sua landing page:",
          defineUrl: "(definir-url)",
          pageActive: "Página activa",
          pageInactive: "Página inactiva",
          pageActiveDescription: "Sua página está publicada e acessível ao público.",
          pageInactiveDescription: "Sua página está em modo rascunho e só ficará visível después de activación.",
          published: "Publicada",
          draft: "Rascunho",
          pageCreated: "Esta página foi creada em {createdDate}",
          pageUpdated: "e atualizada pela última vez em {updatedDate}",
        },

        // Queue section
        queue: {
          label: "Fila de Atención",
          none: "Nenhuma fila",
          loading: "Cargando filas...",
          helperText: "Selecciona uma fila para direcionar os contatos desta landing page",
        },

        // Form fields
        fields: {
          name: "Nombre",
          email: "E-mail",
          phone: "Teléfono",
          namePlaceholder: "Digite seu nome",
          emailPlaceholder: "Digite seu e-mail",
          phonePlaceholder: "Digite seu telefone",
        },

        // Affiliates
        affiliates: {
          title: "Gestionar Afiliados",
          newAffiliate: "Novo Afiliado",
          createFirst: "Crear Primeiro Afiliado",
          noAffiliatesTitle: "Nenhum afiliado registrado",
          noAffiliatesMessage: "Crie afiliados para esta landing page e gere links personalizados para rastreamento.",
          name: "Nombre",
          email: "E-mail",
          phone: "Teléfono",
          commissionRate: "Taxa de Comisson (%)",
          active: "Activo",
          inactive: "Inactivo",
          activeLabel: "Afiliado activo",
          status: "Estado",
          actions: "Acciones",
          uniqueLink: "Link Único",
          qrCode: "QR Code",
          qr: "QR",
          stats: "Stats",
          statistics: "Estatísticas",
          code: "Código",
          clicks: "Clicks",
          conversions: "Conversões",
          rate: "Taxa",
          copyLink: "Copiar Link",
          generateQR: "Gerar QR Code",
          viewStats: "Ver Estatísticas",
          edit: "Editar",
          delete: "Eliminar",
          close: "Cerrar",
          confirmDelete: "¿Estás seguro que quieres eliminar este afiliado?",
          createSuccess: "Afiliado creado com éxito!",
          updateSuccess: "Afiliado actualizado com éxito!",
          deleteSuccess: "Afiliado eliminado com éxito!",
          createError: "Error ao crear afiliado",
          updateError: "Error ao actualizar afiliado",
          deleteError: "Error ao eliminar afiliado",
          loadError: "Error ao carregar afiliados",
          linkCopied: "Link copiado para la área de transferência!",
          linkCopyError: "Error ao copiar link",
          qrTitle: "QR Code - {name}",
          downloadQR: "Baixar QR Code",
          saveQR: "Guardar QR",
          modalTitle: "Gestionar Afiliado",
          modalCreate: "Novo Afiliado",
          modalEdit: "Editar Afiliado",
          cancel: "Cancelar",
          create: "Crear",
          update: "Actualizar",
        },

        table: {
          title: "Título",
          url: "URL",
          status: "Estado",
          qrCode: "QR Code",
          actions: "Acciones",
        },
        actions: {
          copyUrl: "Copiar URL",
          activate: "Clique para lactivar",
          deactivate: "Clique para desactivar",
          viewQrCode: "Ver QR Code",
          edit: "Editar",
          delete: "Eliminar",
        },
        status: {
          active: "Activa",
          inactive: "Inactiva",
        },
        pagination: {
          itemsPerPage: "Itens por página:",
          showing: "{showing} de {total} landing pages",
        },
        modals: {
          deleteTitle: "Eliminar Landing Page",
          deleteMessage: "¿Estás seguro que quieres eliminar esta landing page? Esta acción no pode ser desfeita.",
        },
        messages: {
          companyIdNotFound: "Company ID no encontrado",
          urlCopied: "URL copiada com éxito!",
          urlCopyError: "Error ao copiar URL",
          deleteSuccess: "Landing page eliminada com éxito!",
          deleteError: "Error ao eliminar landing page",
          statusChangeSuccess: "Landing page {status} com éxito!",
          statusChangeError: "Error ao alterar status da landing page",
          activated: "ativada",
          deactivated: "desativada",
          loadError: "Error ao carregar landing pages",
        },
        form: {
          submitSuccess: "Formulario enviado com éxito!",
          submitError: "Error ao enviar formulario. Tente novamente.",
          validationError: "Por favor, corrija os campos destacados.",
          phoneValidation: {
            checking: "Verificando número...",
            valid: "Número válido no WhatsApp",
            invalid: "Número no encontrado no WhatsApp",
            error: "Error ao verificar número",
          },
        },
        queue: {
          label: "Fila de Atención",
          none: "Nenhuma fila (contatos ficam sem fila)",
          helperText: "Selecciona a fila onde os contatos desta landing page se direcionados",
          loading: "Cargando filas...",
        },
      },
      groups: {
        title: "Gerenciamento de Grupos",
        newGroup: "Novo Grupo",
        searchPlaceholder: "Buscar grupos...",
        noGroupsFound: "Nenhum grupo encontrado",
        noGroupName: "Grupo sem nome",
        selectGroupToSeeRequests: "Selecciona um grupo para ver as solicitações de entrada",
        groupDeleted: "Grupo removido com éxito",
        groupForceDeleted: "Grupo removido do sistema com éxito",
        deleteConfirmTitle: "Confirmar Saída do Grupo",
        deleteConfirmMessage: "¿Estás seguro que quieres sair do grupo '{name}'? Você no receberá mais mensajes deste grupo.",
        forceDeleteConfirmTitle: "Confirmar Remoção do Sistema",
        forceDeleteConfirmMessage: "¿Estás seguro que quieres remover o grupo '{name}' do sistema?",
        forceDeleteWarning: "⚠️ Atenção: Esta acción removerá o grupo permanentemente do sistema, incluindo histórico de mensajes e tickets.",
        forceDelete: "Remover do Sistema",
        table: {
          name: "Grupo",
          participants: "Participantes",
          permission: "Permiso",
          createdAt: "Creado em",
        },
        tabs: {
          list: "Lista de Grupos",
          requests: "Solicitações",
          automaticSeries: "Séries Automáticas",
          dashboard: "Dashboard",
          extractContacts: "Extrair Contatos",
          importContacts: "Importar Contactos",
        },
        dashboard: {
          title: "Dashboard de Grupos",
          subtitle: "Monitore métricas e desempenho dos grupos em tempo real",
          metrics: {
            totalGroups: "Total de Grupos",
            managedGroups: "Grupos Gerenciados",
            activeGroups: "Grupos Ativos",
            totalParticipants: "Total de Participantes",
            averageOccupancy: "Ocupação Média",
            activeSeries: "Séries Ativas",
            groupsCreatedToday: "Grupos Criados Hoje",
            nearCapacity: "Próximos da Capacidade",
            totalConnections: "Conexiones Ativas",
            systemHealth: "Saúde do Sistema",
          },
          charts: {
            occupancyDistribution: "Distribuição de Ocupação",
            groupsOverTime: "Grupos ao Largo do Tempo",
            participantsGrowth: "Crescimento de Participantes",
            seriesPerformance: "Performance das Séries",
          },
          recentActivity: {
            title: "Atividades Recentes",
            groupCreated: "Grupo creado automáticamente",
            groupFull: "Grupo atingiu capacidade máxima",
            seriesActivated: "Série ativada",
            participantJoined: "Participante adicionado",
            thresholdReached: "Limite de ocupação atingido",
            monitoringRun: "Verificação automática executada",
          },
          alerts: {
            groupsNearCapacity: "grupos próximos da capacidade",
            seriesNeedAttention: "séries precisam de atenção",
            connectionsDown: "conexiones offline",
          },
          status: {
            healthy: "Saudável",
            warning: "Atenção",
            critical: "Crítico",
            lastCheck: "Última Verificação",
            performance: "Performance do Sistema",
          },
          actions: {
            refresh: "Actualizar",
            runMonitoring: "Executar Monitoreo",
            viewDetails: "Ver Detalhes",
            exportReport: "Exportar Informe",
          }
        },
        permissions: {
          admin: "Administrador",
          participant: "Participante",
          unknown: "Desconhecido",
        },
        actions: {
          view: "Visualizar",
          edit: "Editar",
          extract: "Extrair Contatos",
          requests: "Solicitações",
          leaveGroup: "Sair do Grupo",
          removeFromSystem: "Remover do Sistema",
          sync: "Sincronizar",
          joinGroup: "Entrar em Grupo",
        },
        alerts: {
          syncTitle: "Sincronizar Grupos do WhatsApp",
          syncMessage: "Encontramos {count} conexión(ões) WhatsApp activa(s). Sincronize para importar todos os grupos existentes e crear tickets automáticos.",
          noWhatsAppTitle: "Nenhuma conexión WhatsApp encontrada",
          noWhatsAppMessage: "Para gestionar grupos, você precisa ter pelo menos uma conexión WhatsApp activa. Configure uma conexión WhatsApp primeiro.",
          ticketsCreatedTitle: "Tickets de Grupos Criados",
          ticketsCreatedMessage: "{count} ticket(s) de grupo(s) foram criados durante a sincronização. Verifique sua lista de atenciones.",
        },
        emptyStates: {
          noGroups: {
            title: "Nenhum grupo encontrado",
            description: "Sincronize seus grupos do WhatsApp para começar a gerenciá-los e crear tickets automáticos",
            actionLabel: "Sincronizar Grupos",
          },
          requests: {
            title: "Solicitações de Entrada",
            description: "Selecciona um grupo para ver as solicitações de entrada",
          }
        },
        stats: {
          admin: "Admin",
          participant: "Participante",
          automatic: "Automático",
          series: "Séries",
        },
        toasts: {
          syncComplete: "Sincronização concluída! {ticketsCreated} ticket(s) creado(s) e {ticketsUpdated} ticket(s) reaberto(s). Verifique sua lista de atenciones.",
          newGroupCreated: "Novo grupo creado automáticamente: {groupName}",
          viewTickets: "Ver Tickets",
          // Toast customizados por componente
          titles: {
            // GroupMonitoringDashboard
            dashboardUpdated: "Dashboard Actualizado",
            dataLoaded: "Datos Carregados",
            dashboardError: "Error no Dashboard",
            // GroupSummaryModal
            summaryGenerated: "Resumen Generado",
            dataExported: "Datos Exportados",
            summaryError: "Error no Resumo",
            // GroupSeriesStatusWidget
            statusUpdated: "Status Actualizado",
            seriesActivated: "Série Ativada",
            statusError: "Error no Status",
            // GroupSeriesNotificationProvider
            notificationSent: "Notificação Enviada",
            alertConfigured: "Alerta Configurado",
            notificationError: "Error na Notificação",
            // JoinGroupModal
            groupJoined: "Grupo Ingressado",
            inviteAccepted: "Convite Aceito",
            joinError: "Error no Ingresso",
            // ImportContactsTab
            contactsImported: "Contatos Importados",
            importCompleted: "Importación Concluída",
            importError: "Error na Importación",
            // GroupSeriesTab
            seriesCreated: "Série Creada",
            configurationSaved: "Configuración Salva",
            seriesError: "Error na Série",
            // GroupSeriesInfoModal
            informationSaved: "Información Salvas",
            dataUpdated: "Datos Atualizados",
            informationError: "Error nas Información",
            // GroupSeriesAdvancedSettings
            configurationSaved: "Configuración Salva",
            adjustmentsApplied: "Ajustes Aplicados",
            configurationError: "Error na Configuración",
            // GroupRequestsModal
            requestApproved: "Solicitação Aprovada",
            requestRejected: "Pedido Rejeitado",
            requestError: "Error na Solicitação",
            // GroupInfoModal (já usando informaçõesSalvas e dadosAtualizados)
            // ExtractContactsTab
            contactsExtracted: "Contatos Extraídos",
            fileGenerated: "Archivo Gerado",
            extractionError: "Error na Extração",
            // ExtractContactsFromGroupModal
            extractionCompleted: "Extração Concluída",
            listCreated: "Lista Creada",
            // CreateGroupSeriesModal
            seriesCreated: "Série Creada",
            configurationSaved: "Configuración Salva",
            creationError: "Error na Creación",
            // CreateGroupModal  
            groupCreated: "Grupo Creado",
            configurationSaved: "Configuración Salva",
            creationError: "Error na Creación",
          }
        }
      },
      servicePanel: {
        allowRealTime: "Painel de Atenciones",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atenciones:",
        pending: "Pendientes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara el fluxo?",
        selectAConnection: " Selecciona uma Conexión",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Guardar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe do Atención",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Fecha",
          lastMessage: "Última Mensaje",
          fullReport: "O informe completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "relatório_atención",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensaje",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Crear novo chat",
        searchUser: "Procurar usuario...",
        noUserFound: "Nenhum usuario encontrado",
        noUserAvailable: "Nenhum usuario disponível",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Conversación",
        deleteChatConfirm: "Esta acción no pode ser revertida, confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensaje foi apagada",
        deletedAdmin: "Mensaje apagada - visível apenas para ladministradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm: "¿Estás seguro que quieres eliminar esta mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Selecciona o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensaje...",
        send: "Enviar",
        noMessages: "Nenhuma mensaje",
        loading: "Cargando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensaje original",
        interactiveButtons: {
          quickReply: "Respuesta rápida",
          url: "Abrir link",
          call: "Fazer ligação",
          listItem: "Selecionar opción",
        },
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        deleteMessage: "¿Estás seguro que quieres eliminar esta mensaje?",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Selecciona o chat",
        forward: "Reenviar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensaje",
        loading: "Cargando...",
        error: "Error ao carregar datos",
        addGroupPhoto: "Añadir Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descripción do Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Estás seguro que quieres eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear grupo",
          name: "Nome do grupo",
          description: "Descripción do grupo",
          create: "Crear",
          cancel: "Cancelar",
          save: "Guardar",
          edit: "Editar",
        },
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
        },
      },
      whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        backgroundColorLight: "Cor de Fundo (Tema Claro)",
        backgroundColorDark: "Cor de Fundo (Tema Escuro)",
        backgroundColors: "Cores de Fundo",
        backgroundColorHelp: "Cores de fundo son usadas quando nenhuma imagem de fundo é definida",
        chooseColor: "Escolher Cor",
        preview: "Visualizar",
        delete: "Eliminar",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
        showTabLabels: "Exibir rótulos nas abas",
        showTabLabelsDescription: "Quando deshabilitado, as abas dos tickets exibirão apenas ícones sem texto",
        showTabBadges: "Exibir contadores nas abas",
        showTabBadgesDescription: "Controla a visibilidade dos badges com números nas abas de tickets",
        showActionButtons: "Exibir botões de acción",
        showActionButtonsDescription: "Controla a visibilidade dos botões de acción (todos, novo ticket, cerrar todos, etc.)",
        enableFiltersSection: "Habilitar sección de filtros",
        enableFiltersSectionDescription: "Permite activar/desactivar a funcionalidade de filtros de tickets",

        sections: {
          general: "Configuraciones Gerais",
          generalDescription: "Configure o nome e información básicas da aplicación",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicación",
          interface: "Interface do Sistema",
          interfaceDescription: "Configure opciones de exibição e comportamiento da interface",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecciona quais idiomas estarão disponíveis no sistema",
        }
      },
      talkAi: {
        title: "Talk.Ai",
        selection: {
          title: "O que você gostaria de crear?",
          subtitle: "Escolha entre crear um prompt personalizado ou configurar um assistente de IA",
          createPrompt: "Crear Prompt",
          createPromptDescription: "Crie prompts personalizados para respuestas automatizadas",
          createAssistant: "Crear Asistente",
          createAssistantDescription: "Configure assistentes de IA para latención inteligente",
        },
        assistantType: {
          title: "Tipo de Asistente",
          subtitle: "Escolha o tipo de assistente que quieres crear",
          voiceAssistant: "Asistente de Voz",
          voiceDescription: "Asistente com capacidades de voz para conversaciones por áudio",
          textAssistant: "Asistente de Texto",
          textDescription: "Asistente focado em conversaciones por texto",
        },
        assistants: {
          title: "Asistentes de IA",
          addButton: "Novo Asistente",
          table: {
            name: "Nombre",
            type: "Tipo",
            queue: "Cola",
            status: "Estado",
            actions: "Acciones",
            active: "Activo",
            inactive: "Inactivo",
          },
          form: {
            title: "Crear Asistente",
            editTitle: "Editar Asistente",
            basicInfo: "Información Básicas",
            name: "Nome do Asistente",
            description: "Descripción",
            aiConfiguration: "Configuración da IA",
            openaiApiKey: "Chave da API OpenAI",
            openaiAssistantId: "ID do Asistente OpenAI (opcional)",
            model: "Modelo da IA",
            maxTokens: "Máximo de Tokens",
            temperature: "Temperatura",
            prompt: "Instrucciones do Sistema",
            tools: "Ferramentas Disponíveis",
            toolsDescription: "Selecciona as ferramentas que o assistente pode usar",
            voiceSettings: "Configuraciones de Voz",
            voiceEnabled: "Habilitar Voz",
            ttsVoice: "Voz TTS",
            ttsModel: "Modelo TTS",
            autoTranscribeVoice: "Auto Transcrever Voz",
            autoGenerateVoice: "Auto Gerar Áudio",
            advancedSettings: "Configuraciones Avanzadas",
            maxConversationMessages: "Máximo de Mensajes no Contexto",
            isActive: "Asistente Activo",
            agentMode: "Modo de Agente",
            agentModeDescription: "Configure como o assistente interage com clientes e agentes humanos",
            agentModeType: "Tipo de Modo",
            allowHumanTakeover: "Permitir transferência para humano",
            transferKeywords: "Palavras-chave para transferência",
            transferKeywordsHelp: "Palavras separadas por vírgula que acionam transferência para lagente humano (ex: atendente, humano, transferir)",
            enableWebSocketSuggestions: "Habilitar sugerencias em tempo real",
            suggestionDelay: "Delay das sugerencias (segundos)",
            suggestionDelayHelp: "Tempo em segundos antes de mostrar sugerencias para el agente",
            suggestContextualResponses: "Sugerir respuestas contextuais",
            suggestCustomerInsights: "Sugerir insights do cliente",
            files: "Archivos",
            filesDescription: "Administrar archivos para que el asistente los use como base de conocimiento",
            uploadFile: "Subir Archivo",
            uploading: "Subiendo...",
            noFiles: "No hay archivos subidos",
            save: "Guardar",
            cancel: "Cancelar",
          },
          models: {
            "gpt-4": "GPT-4 - Melhor qualidade",
            "gpt-4-turbo-preview": "GPT-4 Turbo - Otimizado",
            "gpt-3.5-turbo": "GPT-3.5 Turbo - Rápido e econômico"
          },
          ttsModels: {
            "tts-1": "TTS-1 - Predeterminado (rápido)",
            "tts-1-hd": "TTS-1 HD - Alta qualidade"
          },
          messages: {
            created: "Asistente creado com éxito!",
            updated: "Asistente actualizado com éxito!",
            deleted: "Asistente deletado com éxito!",
            fileUploaded: "¡Archivo subido con éxito!",
            fileDeleted: "¡Archivo eliminado con éxito!",
          },
          deleteDialog: {
            title: "Eliminar Asistente",
            message: "¿Estás seguro que quieres eliminar este assistente? Esta acción no pode ser desfeita.",
          },
          agentModes: {
            prompt: "Modo Prompt - Respuesta baseada em instruções fixas",
            agentDirect: "Agente Directo - IA responde diretamente ao cliente",
            agentAssistant: "Asistente de Agente - IA auxilia agentes humanos com sugerencias",
          }
        },
        buttons: {
          back: "Volver",
          startVoiceAssistant: "Iniciar Asistente de Voz",
          voiceAssistantActive: "Asistente de voz activo - Clique para abrir interface",
          voiceAssistantConnected: "Asistente de voz conectado - Clique para lactivar",
          loadingAssistant: "Cargando assistente de voz...",
          noAssistantAvailable: "Nenhum assistente de voz disponível para esta fila",
          configureAssistants: "Configure assistentes de voz para esta fila no painel Talk.AI",
        }
      },
      voiceAssistants: {
        title: "Asistentes de Voz",
        subtitle: "Configure assistentes de voz com IA para latención automatizado",
        addButton: "Novo Asistente",
        searchPlaceholder: "Buscar assistentes...",
        noAssistants: "Nenhum assistente configurado",
        loading: "Cargando assistentes...",
        table: {
          name: "Nombre",
          description: "Descripción",
          queue: "Cola",
          model: "Modelo",
          voice: "Voz TTS",
          status: "Estado",
          actions: "Acciones",
          active: "Activo",
          inactive: "Inactivo",
        },
        form: {
          title: "Asistente de Voz",
          editTitle: "Editar Asistente",
          name: "Nombre",
          namePlaceholder: "Nome do assistente",
          description: "Descripción",
          descriptionPlaceholder: "Descripción do assistente",
          prompt: "Prompt do Sistema",
          promptPlaceholder: "Instrucciones para el assistente de IA...",
          openaiApiKey: "Chave da API OpenAI",
          openaiApiKeyPlaceholder: "sk-...",
          openaiAssistantId: "ID do Asistente OpenAI",
          openaiAssistantIdPlaceholder: "asst_...",
          model: "Modelo OpenAI",
          maxTokens: "Máximo de Tokens",
          temperature: "Temperatura",
          queue: "Fila Associada",
          voiceSettings: "Configuraciones de Voz",
          voiceEnabled: "Habilitar Voz",
          ttsVoice: "Voz TTS",
          ttsModel: "Modelo TTS",
          whisperModel: "Modelo Whisper",
          maxConversationMessages: "Máximo de Mensajes no Contexto",
          autoTranscribeVoice: "Auto Transcrever Voz",
          autoGenerateVoice: "Auto Gerar Respuesta em Voz",
          isActive: "Asistente Activo",
          testConnection: "Testar Conexión",
          save: "Guardar",
          cancel: "Cancelar",
        },
        voices: {
          alloy: "Alloy - Voz neutra e clara",
          echo: "Echo - Voz masculina",
          fable: "Fable - Voz feminina suave",
          onyx: "Onyx - Voz masculina profunda",
          nova: "Nova - Voz feminina jovem",
          shimmer: "Shimmer - Voz feminina brilhante",
        },
        models: {
          "gpt-4": "GPT-4 - Melhor qualidade",
          "gpt-4-turbo-preview": "GPT-4 Turbo - Versión otimizada",
          "gpt-3.5-turbo": "GPT-3.5 Turbo - Rápido e econômico"
        },
        ttsModels: {
          "tts-1": "TTS-1 - Qualidade padrão, mais rápido",
          "tts-1-hd": "TTS-1 HD - Alta qualidade, mais lento"
        },
        messages: {
          created: "Asistente creado com éxito!",
          updated: "Asistente actualizado com éxito!",
          deleted: "Asistente deletado com éxito!",
          connectionSuccess: "Conexión com OpenAI estabelecida com éxito!",
          connectionError: "Error na conexión com OpenAI",
          processVoiceSuccess: "Mensaje de voz processada com éxito!",
          processVoiceError: "Error ao processar mensaje de voz",
        },
        deleteDialog: {
          title: "Eliminar Asistente",
          message: "¿Estás seguro que quieres eliminar este assistente? Esta acción no pode ser desfeita.",
          confirm: "Eliminar",
          cancel: "Cancelar",
        },
        processing: {
          title: "Processamento de Voz",
          transcribing: "Transcrevendo áudio...",
          generatingResponse: "Gerando respuesta...",
          generatingTts: "Gerando áudio TTS...",
          completed: "Processamento concluído",
          error: "Error no processamento",
        },
        streaming: {
          startSession: "Iniciar Sesión de Voz",
          endSession: "Finalizar Sesión",
          recording: "Gravando...",
          processing: "Processando...",
          speaking: "Falando...",
          sessionActive: "Sesión de voz activa",
          sessionEnded: "Sesión finalizada",
          microphonePermission: "Permiso do microfone necessária",
          audioNotSupported: "Áudio no suportado neste navegador",
          connecting: "Conectando...",
          connected: "Conectado",
          disconnected: "Desconectado",
          connectionError: "Error de conexión",
          listening: "Ouvindo...",
          startRecording: "Clique para falar",
          stopRecording: "Clique para parar",
          voiceSettings: "Configuraciones de Voz",
          enableVoiceAssistant: "Habilitar Asistente de Voz",
          disableVoiceAssistant: "Desabilitar Asistente de Voz",
          voiceActivated: "Asistente de voz activado",
          voiceDeactivated: "Asistente de voz desactivado",
        },
        voiceInterface: {
          title: "Asistente de Voz",
          subtitle: "Conversación por voz em tempo real",
          startConversation: "Iniciar Conversación",
          endConversation: "Finalizar Conversación",
          speakNow: "Fale agora",
          tapToSpeak: "Toque para falar",
          releaseToSend: "Solte para enviar",
          holdToTalk: "Segure para falar",
          voiceMessage: "Mensaje de voz",
          transcription: "Transcripción",
          aiResponse: "Respuesta da IA",
          playback: "Reproduzir",
          pause: "Pausar",
          stop: "Parar",
          download: "Baixar",
          waveform: "Forma de onda",
          duration: "Duración",
          timestamp: "Timestamp",
        },
        ttsSettings: {
          title: "Configuraciones de TTS",
          selectVoice: "Selecionar Voz",
          voicePreview: "Prévia da Voz",
          playPreview: "Reproduzir Prévia",
          voice: {
            alloy: "Alloy - Voz neutra e equilibrada",
            echo: "Echo - Voz masculina clara",
            fable: "Fable - Voz feminina suave",
            onyx: "Onyx - Voz masculina profunda",
            nova: "Nova - Voz feminina jovem",
            shimmer: "Shimmer - Voz feminina elegante",
          },
          speed: "Velocidade",
          pitch: "Tom",
          volume: "Volume",
          testText: "Texto de teste",
          defaultTestText: "Olá, esta é uma prévia da voz selecionada.",
          applySettings: "Aplicar Configuraciones",
          resetSettings: "Redefinir",
        },
        audioControls: {
          play: "Reproduzir",
          pause: "Pausar",
          stop: "Parar",
          mute: "Silenciar",
          unmute: "Activar som",
          volumeUp: "Aumentar volume",
          volumeDown: "Diminuir volume",
          seekForward: "Avançar",
          seekBackward: "Retroceder",
          playbackSpeed: "Velocidade de reprodução",
          loading: "Cargando áudio...",
          error: "Error ao carregar áudio",
          duration: "Duración: {duration}",
          currentTime: "Tempo atual: {time}",
        },
        connectionStatus: {
          connecting: "Conectando ao servidor de voz...",
          connected: "Conectado - Pronto para conversar",
          disconnected: "Desconectado - Reconectando...",
          error: "Error de conexión - Tente novamente",
          reconnecting: "Reconectando...",
          timeout: "Timeout de conexión",
          networkError: "Error de rede",
          serverError: "Error do servidor",
        }
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID do usuario ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar o ticket - true/false',
        singMessage: "Assinar mensaje - true/false",
        closeTicket: "Cerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensaje de forma recorrente e escolher o intervalo. Caso seja uma mensaje a ser enviada uma única vez, no altere nada nesta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias no úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexiones.",
        ERR_NO_WHATSAPP_CONNECTION:
          "No se encontró ninguna conexión activa de WhatsApp. Para guardar contactos, debe tener al menos una conexión activa de WhatsApp en la empresa.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión do WhatsApp no foi inicializada. Verifique a página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No foi possível verificar o contato do WhatsApp. Verifique a página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No foi possível baixar mídia do WhatsApp. Verifique a página de conexiones.",
        ERR_INVALID_CREDENTIALS:
          "Error de autenticación. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Error ao enviar mensaje do WhatsApp. Verifique a página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No foi possível eliminar a mensaje do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete abierto para este contato.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuario foi deshabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você no tem permiso para lacessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuración encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuario encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Error ao crear mensaje no banco de datos.",
        ERR_CREATING_TICKET: "Error ao crear tíquete no banco de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error ao buscar a mensaje no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensaje de saludo é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_COMPANY_NOT_FOUND: "Empresa no encontrada.",
        ERR_COMPANY_NO_PLAN: "La empresa no tiene un plan asociado.",
        ERR_CATALOG_NOT_ALLOWED_IN_PLAN: "El catálogo de productos no está disponible en su plan actual.",
        ERR_NO_DEFAULT_WHATSAPP_FOUND: "No se encontró conexión WhatsApp predeterminada. Configure una conexión predeterminada en Conexiones."
      },
      birthday: {
        title: "Aniversários",
        modal: {
          title: "🎉 Aniversariantes de Hoje! 🎂",
          users: "Usuarios:",
          contacts: "Contatos:",
          noData: "Nenhum aniversariante hoje",
          close: "Cerrar",
          userAge: "{{age}} anos",
          contactAge: "{{age}} anos",
          congratulations: "Parabéns!",
        },
        settings: {
          title: "Configuraciones de Aniversário",
          userBirthdayEnabled: "Activar aniversários de usuarios",
          contactBirthdayEnabled: "Activar aniversários de contatos",
          userBirthdayMessage: "Mensaje para usuarios",
          contactBirthdayMessage: "Mensaje para contatos",
          sendBirthdayTime: "Horário de envio",
          createAnnouncementForUsers: "Crear informativos para usuarios",
          save: "Guardar",
          success: "Configuraciones salvas com éxito!",
          placeholders: {
            userMessage: "Parabéns pelo seu aniversário, {nome}!",
            contactMessage: "Parabéns pelo seu aniversário, {nome}! Quieresmos muitas felicidades!",
            sendTime: "09:00:00",
          },
        },
        toast: {
          userBirthday: "🎉 Hoje é aniversário de {{name}}!",
          contactBirthday: "🎂 O contato {{name}} faz aniversário hoje!",
          messageSent: "Mensaje de aniversário enviada com éxito!",
          messageError: "Error ao enviar mensaje de aniversário",
        },
      },
      notificationManager: {
        title: "Notificações Push",
        browserNotSupported: "Seu navegador no suporta notificações push. Atualize para uma versión mais recente ou use Chrome, Firefox, Safari ou Edge.",
        activeDescription: "Você receberá notificações em tempo real sobre novos tickets e mensajes.",
        inactiveDescription: "Ative as notificações para receber alertas em tempo real sobre novos tickets e mensajes.",
        enabled: "Notificações ativadas",
        disabled: "Notificações desativadas",
        sendTest: "Enviar Teste",
        refreshList: "Actualizar Lista",
        activeDevices: "Dispositivos Ativos ({{count}})",
        unknownDevice: "Dispositivo desconhecido",
        unknownBrowser: "Navegador desconhecido",
        registeredAgo: "Registrado {{time}}",
        active: "Activo",
        inactive: "Inactivo",
        permissionDenied: "As notificações están bloqueadas pelo navegador. Para ativá-las, clique no ícone de cadeado na barra de endereços e permita notificações para este site.",
      },
      // Toasts customizados para diferentes contextos
      toasts: {
        ticket: {
          updated: "Ticket Actualizado",
          error: "Error no Ticket",
          statusChanged: "Status Alterado",
          assignmentChanged: "Atribuição Alterada",
          quickMessageError: "Error Respuesta",
        },
        messageInput: {
          sent: "Mensaje enviada com éxito",
          error: "Error ao enviar mensaje",
          fileAttached: "Archivo anexado com éxito",
          invalidFormat: "Formato de archivo inválido",
          aiError: "Error ao processar solicitação de IA",
        },
        campaigns: {
          created: "Campanha creada com éxito",
          started: "Disparo iniciado com éxito",
          paused: "Campanha pausada com éxito",
          removed: "Campanha removida com éxito",
          error: "Error no processamento da campanha",
          accessDenied: "Acesso negado para esta funcionalidade",
          recurrenceStopped: "Recorrência interrompida com éxito",
        },
        contacts: {
          saved: "Contato guardado com éxito",
          updated: "Datos atualizados com éxito",
          removed: "Contato removido com éxito",
          validationError: "Error de validación nos datos",
          duplicateError: "Contato já existe no sistema",
        },
        users: {
          created: "Usuario creado com éxito",
          updated: "Usuario actualizado com éxito",
          removed: "Usuario removido com éxito",
          passwordChanged: "Senha alterada com éxito",
          permissionError: "Error de permiso",
          chatCreated: "Chat creado com éxito",
          chatsGenerated: "Chats gerados com éxito",
        },
        queues: {
          created: "Fila creada com éxito",
          updated: "Fila atualizada com éxito",
          removed: "Fila removida com éxito",
          configSaved: "Configuración salva com éxito",
          error: "Error ao processar fila",
        },
        general: {
          success: "Operación realizada com éxito",
          error: "Error ao processar solicitação",
          loading: "Processando...",
          saved: "Datos salvos com éxito",
          updated: "Actualizado com éxito",
          removed: "Removido com éxito",
        }
      },
      fiscal: {
        title: "Configuración Fiscal",
        subtitle: "Configure datos fiscales y certificado digital para emisión de NFe",
        description: "Complete los datos fiscales de su empresa y cargue el certificado digital para habilitar la emisión de Facturas Electrónicas (NFe).",
        status: {
          incomplete: "Configuración Fiscal Incompleta",
          missingFields: "Campos obligatorios pendientes:"
        },
        validation: {
          title: "Status da Configuración Fiscal",
          ready: "Configuración Fiscal Completa",
          readyDesc: "Sua empresa está pronta para emitir NFe",
          incomplete: "Configuración Fiscal Incompleta",
          incompleteDesc: "campo(s) obrigatório(s) pendente(s)",
          missingFields: "Campos obrigatórios pendentes:",
          warnings: "Avisos:",
        },
        company: {
          title: "Datos da Empresa",
          cnpj: "CNPJ",
          stateRegistration: "Inscrição Estadual",
          municipalRegistration: "Inscrição Municipal",
          fiscalRegime: "Regime Fiscal",
          regimes: {
            SIMPLES_NACIONAL: "Simples Nacional",
            LUCRO_PRESUMIDO: "Lucro Presumido",
            LUCRO_REAL: "Lucro Real",
            MEI: "MEI",
          }
        },
        address: {
          title: "Endereço Fiscal",
          zipCode: "CEP",
          street: "Rua",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "Estado",
          cityCode: "Código IBGE da Cidade",
          stateCode: "Código IBGE do Estado",
        },
        nfe: {
          title: "Configuraciones NFe",
          environment: "Ambiente NFe",
          environments: {
            HOMOLOGACAO: "Homologação (Testes)",
            PRODUCAO: "Produção",
          },
          series: "Série NFe",
          emailFrom: "Email para NFe",
          observations: "Observaciones Fiscais Predeterminado",
          observationsPlaceholder: "Observaciones que aparecerão em todas as NFes...",
          autoGenerate: "Gerar NFe automáticamente quando pedido for faturado",
          autoEmail: "Enviar NFe por email automáticamente",
          autoNapp: "Enviar datos fiscais para NAPP automáticamente",
        },
        certificate: {
          title: "Certificado Digital",
          info: "Certificado A1 necesario: Faça upload do archivo .p12 ou .pfx do seu certificado digital.",
          selectFile: "Selecionar Certificado",
          password: "Senha do Certificado",
          validity: "Validade do Certificado:",
          expired: "Certificado digital expirado",
          valid: "Certificado válido até",
        },
        actions: {
          save: "Guardar Configuración",
          saving: "Salvando...",
          testConnection: "Testar Conexión",
          testing: "Testando...",
        },
        messages: {
          saveSuccess: "Configuración fiscal salva com éxito!",
          saveError: "Error ao guardar configuración fiscal",
          testSuccess: "Teste de conexión realizado com éxito!",
          testError: "Error no teste de conexión",
          loadError: "Error ao carregar configuración fiscal",
        }
      },
      napp: {
        title: "Configuración NAPP E-commerce",
        subtitle: "Configure la integración con NAPP Solutions para gestionar pedidos de e-commerce",
        sections: {
          basicConfiguration: "Configuración Básica",
          notifications: "Notificaciones"
        },
        tabs: {
          connection: "Conexión",
          notifications: "Notificaciones",
          templates: "Templates",
        },
        connection: {
          title: "Configuraciones de Conexión",
          apiKey: "Chave da API",
          apiKeyHelper: "Chave de acesso fornecida pela NAPP Solutions",
          environment: "Ambiente",
          environments: {
            production: "Producción",
            sandbox: "Sandbox",
            staging: "Staging"
          },
          syncInterval: "Intervalo de Sincronização",
          intervals: {
            5: "5 minutos",
            10: "10 minutos",
            15: "15 minutos",
            30: "30 minutos",
            60: "1 hora",
          },
          feedLimit: "Limite de Itens por Sincronização",
          webhookUrl: "URL do Webhook",
          webhookHelper: "📝 Esta é a URL que você deve configurar no painel da NAPP para receber atualizações automáticas de pedidos",
          testConnection: "Testar Conexión",
          saveConfig: "Guardar Configuración",
        },
        notifications: {
          title: "Configuraciones de Notificações",
          autoCreateContacts: "Crear Contatos Automáticamente",
          autoCreateContactsHelper: "Crear contatos automáticamente a partir dos datos do cliente no pedido",
          enableNotifications: "Habilitar Notificações WhatsApp",
          enableNotificationsHelper: "Enviar notificações automáticas via WhatsApp para clientes",
          statusNotifications: "Status que Acionam Notificações",
          createTickets: "Crear Tickets Automáticamente",
          createTicketsHelper: "Crear tickets automáticamente para determinados status de pedido",
          statusTickets: "Status que Criam Tickets",
        },
        templates: {
          title: "Templates de Notificação",
          description: "📝 Habilite as notificações WhatsApp para configurar os templates de mensaje",
          status: {
            PAYMENT_APPROVED: "Pagamento Aprovado",
            SHIPMENT: "Produto Enviado",
            DELIVERED: "Produto Entregue",
            CANCELLED: "Pedido Cancelado",
            PAYMENT_PENDING: "Pagamento Pendente",
            IN_PREPARATION: "Em Preparación",
            READY_FOR_PICKUP: "Pronto para Retirada",
          }
        },
        buttons: {
          save: "Guardar",
          cancel: "Cancelar",
          test: "Probar",
          sync: "Sincronizar Agora",
        },
        messages: {
          saveSuccess: "Configuración NAPP salva com éxito!",
          saveError: "Error ao guardar configuración NAPP",
          testSuccess: "Conexión probada com éxito!",
          testError: "Error ao testar conexión",
          syncSuccess: "Sincronização iniciada com éxito!",
          syncError: "Error ao iniciar sincronização",
          loadError: "Error ao carregar configuraciones NAPP",
        },
        validation: {
          apiKeyRequired: "Chave da API é obrigatória",
          environmentRequired: "Ambiente é obrigatório",
          intervalRequired: "Intervalo de sincronização é obrigatório",
        }
      },
      orders: {
        title: "Pedidos E-commerce",
        subtitle: "Gerenciamento de pedidos sincronizados da NAPP Solutions",
        table: {
          code: "Código",
          customer: "Cliente",
          platform: "Plataforma",
          status: "Estado",
          total: "Total",
          date: "Fecha",
          actions: "Acciones",
        },
        status: {
          PAYMENT_PENDING: "Pagamento Pendente",
          PAYMENT_APPROVED: "Pagamento Aprovado",
          IN_PREPARATION: "Em Preparación",
          READY_FOR_PICKUP: "Pronto para Retirada",
          SHIPMENT: "Enviado",
          DELIVERED: "Entregue",
          CANCELLED: "Cancelado",
          REFUNDED: "Reembolsado",
        },
        filters: {
          title: "Filtros",
          status: "Estado",
          platform: "Plataforma",
          customer: "Cliente",
          dateRange: "Período",
          search: "Buscar",
          clear: "Limpar",
        },
        details: {
          title: "Detalhes do Pedido",
          orderInfo: "Información do Pedido",
          customerInfo: "Datos do Cliente",
          items: "Itens",
          timeline: "Histórico",
          notifications: "Notificações",
        },
        buttons: {
          viewDetails: "Ver Detalhes",
          updateStatus: "Actualizar Status",
          resendNotification: "Reenviar Notificação",
          close: "Cerrar",
        },
        messages: {
          loadError: "Error ao carregar pedidos",
          updateSuccess: "Status do pedido actualizado com éxito!",
          updateError: "Error ao actualizar status do pedido",
          notificationSuccess: "Notificação reenviada com éxito!",
          notificationError: "Error ao reenviar notificação",
        }
      },
      orderAnalytics: {
        title: "Analytics de Pedidos",
        subtitle: "Métricas e informes de performance dos pedidos e-commerce",
        tabs: {
          overview: "Vison Geral",
          platforms: "Plataformas",
          performance: "Performance",
          reports: "Informes",
        },
        kpis: {
          totalOrders: "Total de Pedidos",
          totalRevenue: "Receita Total",
          averageValue: "Ticket Medio",
          conversionRate: "Taxa de Converson",
          completedOrders: "Pedidos Concluídos",
          pendingOrders: "Pedidos Pendientes",
          cancelledOrders: "Pedidos Cancelados",
        },
        charts: {
          ordersOverTime: "Pedidos ao Largo do Tempo",
          revenueOverTime: "Receita ao Largo do Tempo",
          statusDistribution: "Distribuição por Status",
          platformComparison: "Comparação por Plataforma",
          topProducts: "Produtos Mais Vendidos",
        },
        periods: {
          today: "Hoje",
          yesterday: "Ontem",
          last7days: "Últimos 7 dias",
          last30days: "Últimos 30 dias",
          thisMonth: "Este mês",
          lastMonth: "Mês anterior",
          custom: "Período personalizado",
        },
        buttons: {
          export: "Exportar",
          refresh: "Actualizar",
          viewReport: "Ver Informe",
        },
        messages: {
          loadError: "Error ao carregar analytics",
          exportSuccess: "Informe exportado com éxito!",
          exportError: "Error ao exportar informe",
          noData: "Nenhum dado disponível para el período seleccionado",
        }
      },
      sales: {
        management: {
          title: "Central de Vendas",
          subtitle: "Gestán Avançada de Performance de Vendas",
          tab: "Vendas",
        },
        kpis: {
          totalRevenue: "Receita Total",
          totalOrders: "Total de Pedidos",
          averageOrderValue: "Ticket Medio",
          conversionRate: "Taxa de Converson",
          newCustomers: "Novos Clientes",
          growth: "Crescimento",
        },
        charts: {
          salesTrends: "Tendências de Vendas",
          platformPerformance: "Performance por Plataforma",
          platformComparison: "Análise Comparativa de Plataformas",
          topPerformer: "Top Performer",
        },
        filters: {
          period: "Período",
          last7days: "Últimos 7 dias",
          last30days: "Últimos 30 dias",
          last90days: "Últimos 90 dias",
          lastYear: "Último ano",
          platform: "Plataforma",
          allPlatforms: "Todas",
          grouping: "Agrupamento",
          daily: "Diário",
          weekly: "Semanal",
          monthly: "Mensal",
        },
        platformMetrics: {
          orders: "Pedidos",
          revenue: "Receita",
          averageValue: "Ticket Medio",
          conversion: "Converson",
          growth: "vs período anterior",
        },
        export: {
          json: "JSON",
          csv: "CSV",
          success: "Informe exportado com éxito",
          error: "Error ao exportar informe",
        },
        buttons: {
          refresh: "Actualizar datos",
          export: "Exportar",
          viewDetails: "Ver Detalhes",
        },
        messages: {
          loadError: "Error ao carregar datos de vendas",
          refreshSuccess: "Datos atualizados com éxito",
          noData: "Nenhum dado disponível para el período seleccionado",
        }
      },
      napp: {
        notConfigured: {
          orders: {
            title: "Pedidos E-commerce No Configurados",
            subtitle: "Para visualizar e gestionar seus pedidos de e-commerce, você precisa configurar a integración com a NAPP Solutions.",
          },
          analytics: {
            title: "Analytics de Pedidos No Disponível",
            subtitle: "Para acessar as análises avanzadas e métricas de performance dos seus pedidos, configure primeiro a integración NAPP.",
          },
          sales: {
            title: "Central de Vendas No Configurada",
            subtitle: "Para acessar o dashboard executivo e análises avanzadas de vendas, você precisa configurar a integración com a NAPP Solutions.",
          },
          general: {
            title: "Integración NAPP No Configurada",
            subtitle: "Para acessar os recursos de e-commerce, você precisa configurar a integración com a NAPP Solutions.",
          },
          info: {
            title: "Como Configurar",
            description: "A integración NAPP Solutions permite sincronizar pedidos de marketplaces como iFood, Americanas, Magazine Luiza e outros. Você receberá uma chave de API da NAPP para configurar a conexión.",
          },
          configureButton: "Configurar Integración NAPP",
          support: "Precisa de ajuda? Entre em contato com o suporte da NAPP Solutions",
        },
        features: {
          orders: {
            title: "Gestán de Pedidos",
            description: "Sincronize e gerencie pedidos de todas as suas plataformas de e-commerce em um só lugar.",
          },
          analytics: {
            title: "Analytics Avanzado",
            description: "Acompanhe métricas detalladas, KPIs e performance de vendas com dashboards interativos.",
          },
          sales: {
            title: "Central de Vendas",
            description: "Dashboard executivo com análise comparativa entre plataformas e informes avanzados.",
          }
        }
      },
      logistics: {
        title: "Sistema de Logística",
        description: "Gerencie rastreamento, entregas e acompanhe toda a jornada logística dos seus pedidos",
        tracking: {
          title: "Rastreamento",
          code: "Código de Rastreamento",
          url: "URL de Rastreamento",
          provider: "Provedor",
          carrier: "Transportadora",
          estimatedDelivery: "Previson de Entrega",
          status: "Estado",
          lastUpdate: "Última Actualización",
          noTracking: "Nenhuma información de rastreamento disponível",
          updateTracking: "Actualizar Rastreamento",
          syncExternal: "Sincronizar com Provedor",
          updateSuccess: "Rastreamento actualizado com éxito!",
          updateError: "Error ao actualizar rastreamento",
          fetchError: "Error ao consultar rastreamento",
          timeline: "Timeline de Eventos",
          addEvent: "Añadir Evento",
        },
        delivery: {
          title: "Entrega",
          status: "Status de Entrega",
          deliveredAt: "Data de Entrega",
          recipientName: "Nome do Recebedor",
          location: "Local",
          updateDelivery: "Actualizar Entrega",
          markAsDelivered: "Marcar como Entregue",
          deliveryFailed: "Entrega Falhada",
          updateSuccess: "Status de entrega actualizado com éxito!",
          updateError: "Error ao actualizar status de entrega",
        },
        events: {
          ORDER_CREATED: "Pedido Creado",
          PAYMENT_CONFIRMED: "Pagamento Confirmado",
          IN_PREPARATION: "Em Preparación",
          READY_FOR_PICKUP: "Pronto para Retirada",
          SHIPPED: "Enviado",
          OUT_FOR_DELIVERY: "Saiu para Entrega",
          DELIVERED: "Entregue",
          DELIVERY_FAILED: "Falha na Entrega",
          RETURNED: "Devolvido",
          CANCELLED: "Cancelado",
          CUSTOMS_CLEARANCE: "Liberação Alfandegária",
          SORTING_CENTER: "Centro de Distribuição",
          TRANSFER: "Em Trânsito",
          VEHICLE_LOADED: "Carregado no Veículo",
          DELIVERY_ATTEMPTED: "Tentativa de Entrega",
        },
        providers: {
          NAPP: "NAPP Solutions",
          CORREIOS: "Correios",
          LOGGI: "Loggi",
          JADLOG: "Jadlog",
          TOTAL_EXPRESS: "Total Express",
          AZUL_CARGO: "Azul Cargo",
          MERCADO_ENVIOS: "Mercado Envios",
          IFOOD: "iFood Delivery",
          UBER_DIRECT: "Uber Direct",
          other: "Outro",
        },
        sync: {
          title: "Sincronização",
          external: "Sincronização Externa",
          selectProvider: "Selecionar Provedor",
          syncNow: "Sincronizar Agora",
          autoSync: "Sincronização Automática",
          success: "Sincronização realizada com éxito!",
          error: "Error na sincronização",
          lastSync: "Última Sincronização",
        },
        stats: {
          title: "Estatísticas de Logística",
          totalOrders: "Total de Pedidos",
          ordersWithTracking: "Com Rastreamento",
          delivered: "Entregues",
          inTransit: "Em Trânsito",
          pending: "Pendientes",
          averageDeliveryTime: "Tempo Medio de Entrega",
          deliveryPerformance: "Performance de Entrega",
          onTime: "No Prazo",
          delayed: "Atrasados",
          failed: "Falharam",
          byProvider: "Por Provedor",
          fetchError: "Error ao carregar estatísticas",
          days: "dias",
          percentage: "%",
        },
        validation: {
          codeRequired: "Código de rastreamento é obrigatório",
          codeLength: "Código deve ter entre 3 e 50 caracteres",
          correiosFormat: "Formato inválido. Use: AA123456789BR",
          providerRequired: "Provedor é obrigatório",
          statusRequired: "Status é obrigatório",
        },
        buttons: {
          save: "Guardar",
          cancel: "Cancelar",
          update: "Actualizar",
          sync: "Sincronizar",
          track: "Rastrear",
          viewDetails: "Ver Detalhes",
          addTracking: "Añadir Rastreamento",
          editTracking: "Editar Rastreamento",
        },
        messages: {
          noEvents: "Nenhum evento de rastreamento encontrado",
          trackingAdded: "Código de rastreamento adicionado!",
          eventAdded: "Evento adicionado à timeline",
          syncStarted: "Sincronização iniciada...",
          dataUpdated: "Datos atualizados com éxito",
        },
        modal: {
          addTracking: {
            title: "Añadir Rastreamento",
            description: "Informe os datos de rastreamento do pedido",
          },
          updateDelivery: {
            title: "Actualizar Entrega",
            description: "Atualize o status de entrega do pedido",
          },
          trackingDetails: {
            title: "Detalhes do Rastreamento",
            description: "Timeline completa do rastreamento",
          }
        }
      },
      messageReactions: {
        reaction: "reação",
        reactions: "reacciones",
        youReacted: "você reagiu",
      },
      // Configuraciones Settings - Padronização
      birthdaySettings: {
        title: "Configurações de Aniversário",
        description: "Configure notificações automáticas de aniversário para usuarios e contatos",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
        loading: "Cargando configuraciones...",
        saving: "Salvando...",
        save: "Guardar Configuraciones",
        refresh: "Actualizar",
        sections: {
          userBirthdays: "Aniversários de Usuarios",
          contactBirthdays: "Aniversários de Contatos",
          generalSettings: "Configuraciones Gerais",
        },
        userBirthdayEnabled: {
          title: "Habilitar aniversários de usuarios",
          description: "Enviar notificações automáticas nos aniversários dos usuarios do sistema",
        },
        contactBirthdayEnabled: {
          title: "Habilitar aniversários de contatos",
          description: "Enviar notificações automáticas nos aniversários dos contatos",
        },
        createAnnouncementForUsers: {
          title: "Crear anúncios para usuarios",
          description: "Crear anúncios automáticos nos aniversários dos usuarios",
        },
        userBirthdayMessage: {
          title: "Mensaje de aniversário do usuario",
          description: "Personalize a mensaje enviada nos aniversários dos usuarios",
        },
        contactBirthdayMessage: {
          title: "Mensaje de aniversário do contato",
          description: "Personalize a mensaje enviada nos aniversários dos contatos",
        },
        sendBirthdayTime: {
          title: "Horário de envio",
          description: "Defina o horário para envio das notificações de aniversário",
        },
        defaultMessages: {
          userBirthday: "🎉 Feliz aniversário! Quieresmos muito éxito e felicidade!",
          contactBirthday: "🎂 Feliz aniversário! Que este novo ano seja repleto de alegrias!",
        },
        messages: {
          saveSuccess: "Configuraciones salvas com éxito!",
          saveSuccessDesc: "As configuraciones de aniversário foram atualizadas",
          saveError: "Error ao guardar configuraciones",
        },
        errors: {
          title: "Error nas Configuraciones",
          loadFailed: "Falha ao carregar configuraciones",
          routeNotFound: "Rota de configuraciones no encontrada",
          unauthorized: "Sem permiso para lacessar configuraciones",
          serverError: "Error interno do servidor",
          networkError: "Error de conexión",
          generic: "Error inesperado",
        },
        debug: {
          title: "Información de Debug",
          toggle: "Alternar Debug",
          fetchingSettings: "Buscando configuraciones...",
          userInfo: "Usuario: {{name}} (ID: {{id}}, Empresa: {{companyId}})",
          responseReceived: "Respuesta recebida",
          settingsLoaded: "Configuraciones carregadas com éxito",
          requestError: "Error na requisição",
          fetchCompleted: "Busca finalizada",
          componentMounted: "Componente montado",
          settingChanged: "Configuración alterada: {{field}} = {{value}}",
          saving: "Salvando configuraciones...",
          saveSuccess: "Configuraciones salvas com éxito",
          saveError: "Error ao guardar configuraciones",
        }
      },
      finalizationSettings: {
        title: "Finalização de Atención",
        description: "Configure motivos de finalização e opciones de valor de venda",
        sections: {
          generalSettings: "Configuraciones Gerais",
          finalizationReasons: "Motivos de Finalização",
        },
        salesValue: {
          label: "Informar valor da venda ao finalizar atención",
          description: "Quando habilitado, o campo de valor da venda aparecerá no modal de finalização",
        },
        addReason: "Añadir Motivo",
        table: {
          name: "Nombre",
          description: "Descripción",
          actions: "Acciones",
          noDescription: "Sem descripción",
        },
        actions: {
          edit: "Editar",
          delete: "Eliminar",
        },
        noReasons: "Nenhum motivo registrado. Clique em 'Añadir' para crear o primeiro.",
        confirmDelete: "¿Estás seguro que quieres eliminar este motivo?",
        modal: {
          addTitle: "Añadir Motivo",
          editTitle: "Editar Motivo",
          nameLabel: "Nome do Motivo",
          nameRequired: "Nome é obrigatório",
          descriptionLabel: "Descripción (opcional)",
          descriptionPlaceholder: "Descreva o motivo da finalização",
          cancel: "Cancelar",
          add: "Añadir",
          update: "Actualizar",
          saving: "Salvando...",
        },
        messages: {
          success: "Configuraciones Salvas",
          reasonCreated: "Motivo creado com éxito!",
          reasonUpdated: "Motivo actualizado com éxito!",
          reasonDeleted: "Motivo eliminado com éxito!",
          settingUpdated: "Configuración atualizada com éxito!",
        },
        errors: {
          title: "Error na Configuración",
          fetchFailed: "Error ao buscar motivos",
          nameRequired: "Nome do motivo é obrigatório",
          saveReason: "Error ao guardar motivo",
          deleteReason: "Error ao eliminar motivo",
          updateSetting: "Error ao actualizar configuración",
        }
      },
      uploaderCert: {
        title: "Certificado Digital",
        description: "Upload e gerenciamento de certificados digitais para API PIX",
        sections: {
          uploadCertificate: "Upload de Certificado",
        },
        status: {
          fileSelected: "Archivo Seleccionado",
          noFile: "Nenhum Archivo",
          p12Format: "Formato P12",
          uploaded: "Enviado",
        },
        form: {
          selectOption: "Escolha uma opción",
          efiCertificate: "Certificado Efí p12 API PIX",
          uploadTitle: "Clique ou arraste o certificado aqui",
          uploadDescription: "Suporte para larchivos .p12 (máximo 10MB)",
          selectedFile: "Archivo seleccionado",
          uploadButton: "Enviar Certificado",
          uploading: "Enviando...",
        },
        messages: {
          fileSelected: "Archivo Seleccionado",
          success: "Archivo Carregado",
          uploadSuccess: "Archivo enviado com éxito!",
        },
        warnings: {
          title: "Upload Pendente",
          selectFile: "Escolha um archivo!",
          selectOption: "Escolha um destino!",
        },
        errors: {
          title: "Error na Configuración",
          noPermission: "Sem permiso para lacessar!",
          invalidFormat: "Use somente archivos em formato p12!",
          uploadFailed: "Error ao enviar archivo",
        }
      },
      performanceMonitor: {
        title: "Monitor de Performance",
        description: "Monitoreo em tempo real do cache de configuraciones e detecção de loops",
        sections: {
          metrics: "Métricas de Performance",
          systemStatus: "Status do Sistema",
        },
        status: {
          healthy: "Saudável",
          loopsDetected: "Loops Detectados",
          hitRate: "Taxa de Acerto",
          requests: "Requisições",
          excellent: "Excelente",
          warning: "Atenção",
          critical: "Crítico",
          unknown: "Desconhecido",
        },
        metrics: {
          hitRate: "Hit Rate",
          hitRateDesc: "Taxa de acerto do cache",
          requests: "Requisições",
          requestsDesc: "Total de requisições",
          response: "Respuesta",
          responseDesc: "Tempo médio de respuesta",
          cache: "Cache",
          cacheDesc: "Hits / Misses",
        },
        system: {
          loopDetection: "Detecção de Loops Infinitos",
          loopsDetected: "loops detectados nos últimos 30 minutos",
          noLoops: "Nenhum loop infinito detectado recentemente",
          cacheEfficiency: "Eficiência do Cache",
          hits: "de acertos",
          requestsPerHour: "Requisições por Hora",
          requestsLastHour: "requisições na última hora",
        },
        actions: {
          refresh: "Actualizar",
          resetMetrics: "Reset Métricas",
        },
        lastUpdate: "Última actualización",
        lastReset: "Última reset",
      },
      asterisk: {
        phone: "Teléfono",
        call: "Chamada",
        calling: "Chamando...",
        ringing: "Tocando...",
        answered: "Atendida",
        hangup: "Desligar",
        answer: "Atender",
        hold: "Reter",
        transfer: "Transferir",
        record: "Gravar",
        mute: "Silenciar",
        unmute: "Activar som",
        bridge: "Conferência",
        settings: "Configuraciones Asterisk",
        testConnection: "Testar Conexión",
        newConnection: "Nova Conexión",
        editConnection: "Editar Conexión",
        deleteConnection: "Eliminar Conexión",
        connectionName: "Nome da Conexión",
        host: "Host/IP",
        port: "Porta",
        username: "Usuario",
        password: "Contraseña",
        secure: "Conexión Segura (HTTPS/WSS)",
        status: "Estado",
        connected: "Conectado",
        disconnected: "Desconectado",
        connecting: "Conectando...",
        error: "Error",
        connect: "Conectar",
        disconnect: "Desconectar",
        actions: "Acciones",
        duration: "Duración",
        direction: "Direção",
        inbound: "Entrada",
        outbound: "Saída",
        callerNumber: "Número Chamador",
        calleeNumber: "Número Chamado",
        startTime: "Hora Início",
        endTime: "Hora Fim",
        failed: "Falhou",
        busy: "Ocupado",
        noAnswer: "No Atendida",
        recording: "Gravação",
        contact: "Contacto",
        ticket: "Ticket",
        user: "Usuario",
        idle: "Inactivo",
        incoming: "Recebendo",
        reject: "Recusar",
        resume: "Retomar",
        activeCall: "Chamada Activa",
        incomingCall: "Chamada Recebida",
        enterPhoneNumber: "Digite o número do telefone",
        selectConnection: "Selecciona uma conexión",
        connection: "Conexión",
        close: "Cerrar",
        backspace: "Volver",
        clear: "Limpar",
        noCallHistory: "Nenhum histórico de chamadas",
        createTicket: "Crear Ticket",
        initiateCall: "Iniciar Chamada",
        enterNumber: "Digite o número",
        callInitiated: "Chamada iniciada com éxito",
        callAnswered: "Chamada atendida",
        callEnded: "Chamada finalizada",
        connectionTested: "Conexión probada com éxito",
        connectionError: "Error na conexión",
        noActiveConnections: "Nenhuma conexión activa encontrada",
        notifications: {
          callIncoming: "Chamada recebida de {{number}}",
          callAnswered: "Chamada atendida",
          callHangup: "Chamada finalizada",
          connectionConnected: "Conexión {{name}} estabelecida",
          connectionDisconnected: "Conexión {{name}} perdida",
          connectionError: "Error na conexión {{name}}: {{error}}",
        },
        dialpad: {
          title: "Discador",
          placeholder: "Digite o número...",
        },
        callModal: {
          title: "Chamada Activa",
          callTo: "Ligando para",
          callFrom: "Recebendo de",
          timer: "Duración",
        },
        forms: {
          validation: {
            nameRequired: "Nome é obrigatório",
            hostRequired: "Host é obrigatório",
            usernameRequired: "Usuario é obrigatório",
            passwordRequired: "Senha é obrigatória",
            portRange: "Porta deve estar entre 1 e 65535",
            numberRequired: "Número é obrigatório",
            connectionExists: "Já existe uma conexión com este nome",
          }
        },
        toasts: {
          connectionCreated: "Conexión creada com éxito",
          connectionUpdated: "Conexión atualizada com éxito",
          connectionDeleted: "Conexión deletada com éxito",
          connectionTested: "Conexión probada com éxito",
          connectionConnected: "Conectado com éxito",
          connectionDisconnected: "Desconectado com éxito",
          callInitiated: "Chamada iniciada",
          callAnswered: "Chamada atendida",
          callHangup: "Chamada finalizada",
          callEnded: "Chamada finalizada",
          callMuted: "Chamada silenciada",
          callUnmuted: "Som da chamada activado",
          callOnHold: "Chamada em espera",
          callResumed: "Chamada retomada",
          connectionTestFailed: "Falha no teste de conexión",
          callHistoryDeleted: "Histórico de chamada eliminado com éxito",
          callHistoryExported: "Histórico de chamadas exportado com éxito",
          endpointCreated: "Endpoint creado com éxito",
          endpointUpdated: "Endpoint actualizado com éxito",
          endpointDeleted: "Endpoint eliminado com éxito",
          error: "Error na operación",
        },
        // New translations for AsteriskPhone components
        missed: "Perdida",
        unknownCaller: "Desconhecido",
        rejectCall: "Recusar Chamada",
        answerCall: "Atender Chamada",
        hangupCall: "Desligar Chamada",
        callTo: "Ligar para",
        makeCall: "Fazer Chamada",
        maximize: "Maximizar",
        minimize: "Minimizar",
        history: "Histórico",
        conference: "Conferência",
        callConnected: "Chamada Conectada",
        callRinging: "Tocando",
        callMissed: "Chamada Perdida",
        sendMessage: "Enviar Mensaje",
        callBack: "Retornar Chamada",
        unknwon: "Desconhecido",
        // CallTransfer translations
        transferCall: "Transferir Chamada",
        transferType: "Tipo de Transferência",
        blindTransfer: "Transferência Direta",
        attendedTransfer: "Transferência Assistida",
        immediate: "Imediato",
        consultFirst: "Consultar Primeiro",
        transferDestination: "Destino da Transferência",
        enterNumberOrExtension: "Digite número ou ramal",
        searchContacts: "Buscar Contatos",
        searchByNameOrNumber: "Buscar por nome ou número",
        noContactsFound: "Nenhum contato encontrado",
        transferSummary: "Resumo da Transferência",
        from: "De",
        to: "Para",
        type: "Tipo",
        notSelected: "No seleccionado",
        cancel: "Cancelar",
        startConsult: "Iniciar Consulta",
        transferNow: "Transferir Agora",
        completeTransfer: "Completar Transferência",
        consultCallActive: "Chamada de Consulta Activa",
        cancelConsult: "Cancelar Consulta",
        // CallBridge translations
        conferenceCall: "Chamada em Conferência",
        participants: "Participantes",
        activeParticipants: "Participantes Ativos",
        totalParticipants: "Total de Participantes",
        bridgeId: "ID da Ponte",
        noParticipants: "Nenhum Participante",
        addParticipantsToStart: "Adicione participantes para começar",
        addParticipant: "Añadir Participante",
        phoneNumber: "Número de Telefone",
        enterPhoneNumber: "Digite o número de telefone",
        add: "Añadir",
        host: "Moderador",
        muted: "Silenciado",
        speaking: "Falando",
        removeParticipant: "Remover Participante",
        conferenceSettings: "Configuraciones da Conferência",
        recordConference: "Gravar Conferência",
        muteOnJoin: "Silenciar ao Entrar",
        waitForHost: "Aguardar Moderador",
        maxParticipants: "Máximo de Participantes",
        updateSettings: "Actualizar Configuraciones",
        addParticipant: "Añadir Participante",
        muteAll: "Silenciar Todos",
        endConference: "Cerrar Conferência",
        unhold: "Retirar de Espera",
        stopRecording: "Parar Gravação",
        startRecording: "Iniciar Gravação",
        // CallRecording translations
        callRecording: "Gravação de Chamada",
        recordingSettings: "Configuraciones de Gravação",
        recordingInProgress: "Gravação em Andamento",
        recordingReady: "Pronto para Gravar",
        recording: "Gravando",
        nowPlaying: "Reproduzindo",
        audioFormat: "Formato de Áudio",
        recordQuality: "Qualidade da Gravação",
        low: "Baja",
        medium: "Media",
        high: "Alta",
        autoSaveRecordings: "Guardar Gravações Automáticamente",
        cloudSync: "Sincronização na Nuvem",
        saveSettings: "Guardar Configuraciones",
        savedRecordings: "Gravações Salvas",
        noRecordings: "Nenhuma Gravação",
        recordingsWillAppearHere: "As gravações aparecerão aqui",
        playRecording: "Reproduzir Gravação",
        downloadRecording: "Baixar Gravação",
        deleteRecording: "Eliminar Gravação",
        confirmDeleteRecording: "¿Estás seguro que quieres eliminar esta gravação?",
        storageUsage: "Uso de Armazenamento",
        // CallHistory translations
        dateTime: "Data/Hora",
        rowsPerPage: "Filas por página",
        of: "de",
        deleteRecord: "Eliminar Registro",
        callHistoryWillAppearHere: "O histórico de chamadas aparecerá aqui",
        // CallNotification translations
        unknown: "Desconhecido",
        // AsteriskSettings translations
        connectionInfo: "Información da Conexión",
        authentication: "Autenticación",
        advancedSettings: "Configuraciones Avanzadas",
        connectionNameHelp: "Nome identificador para esta conexión",
        hostHelp: "IP ou hostname do servidor Asterisk",
        portHelp: "Porta do serviço ARI (padrão: 8088)",
        secureHelp: "Use HTTPS/WSS para conexión segura",
        usernameHelp: "Usuario configurado no Asterisk para ARI",
        passwordHelp: "Senha do usuario ARI",
        applicationNameHelp: "Nome da aplicación registrada no Asterisk",
        reconnectAttemptsHelp: "Número de tentativas de reconexão",
        reconnectIntervalHelp: "Intervalo entre tentativas em milissegundos",
        timeoutHelp: "Timeout de conexión em milissegundos",
        isActiveHelp: "Conexión activa e disponível para uso",
        testing: "Testando...",
        saving: "Salvando...",
        previous: "Anterior",
        next: "Próximo",
        updateConnection: "Actualizar Conexión",
        createConnection: "Crear Conexión",
        saveConnectionFailed: "Falha ao guardar conexión",
        testConnectionHelp: "Teste a conectividade e funcionalidade desta conexión",
        // EndpointForm translations
        userAssignment: "Atribuição de Usuario",
        selectUser: "Selecciona um usuario para este endpoint",
        noUsersAvailable: "Nenhum usuario disponível para endpoint",
        selectedUser: "Usuario Seleccionado",
        basicConfiguration: "Configuración Básica",
        endpointName: "Nome do Endpoint",
        endpointNameHelp: "Nome identificador do endpoint",
        endpointIdentifier: "Identificador do Endpoint",
        endpointIdentifierHelp: "Identificador único no Asterisk",
        contextHelp: "Contexto de discagem no dialplan",
        codecHelp: "Codecs suportados separados por vírgula",
        dtmfMode: "Modo DTMF",
        directMedia: "Mídia Direta",
        directMediaHelp: "Permitir mídia direta entre endpoints",
        mailboxHelp: "Caixa postal associada (opcional)",
        configurationPreview: "Visualização da Configuración",
        testEndpoint: "Testar Endpoint",
        testEndpointHelp: "Teste a configuración do endpoint",
        updateEndpoint: "Actualizar Endpoint",
        createEndpoint: "Crear Endpoint",
        saveEndpointFailed: "Falha ao guardar endpoint",
        endpointTestFailed: "Falha no teste do endpoint",
        confirmDeleteConnection: "¿Estás seguro que quieres eliminar esta conexión?",
        confirmDeleteEndpoint: "¿Estás seguro que quieres eliminar este endpoint?",
        userNotFound: "Usuario no encontrado",
        // TestConnection translations
        networkConnectivity: "Conectividade de Rede",
        networkConnectivityDesc: "Verificar conectividade básica com o servidor",
        authenticationDesc: "Verificar credenciais de autenticación",
        asteriskConnection: "Conexión Asterisk",
        asteriskConnectionDesc: "Estabelecer conexión ARI com Asterisk",
        performanceTest: "Teste de Performance",
        performanceTestDesc: "Medir latência e throughput",
        functionalTest: "Teste Funcional",
        functionalTestDesc: "Verificar funcionalidades básicas",
        startingTest: "Iniciando teste para",
        testingNetworkConnectivity: "Testando conectividade de rede...",
        testingAuthentication: "Testando autenticación...",
        testingAsteriskConnection: "Testando conexión Asterisk...",
        testingPerformance: "Testando performance...",
        testingFunctionality: "Testando funcionalidades...",
        testCompletedWithErrors: "Teste concluído com errores",
        testCompletedWithWarnings: "Teste concluído com avisos",
        testCompletedSuccessfully: "Teste concluído com éxito",
        testFailed: "Teste falhou",
        testProgress: "Progresso do Teste",
        networkConnectivitySuccess: "Conectividade de rede OK",
        networkConnectivityFailed: "Falha na conectividade de rede",
        slowNetworkResponse: "Respuesta de rede lenta",
        slowResponse: "Respuesta lenta",
        networkConnected: "Rede conectada",
        networkError: "Error de rede",
        authenticationSuccess: "Autenticación bem-sucedida",
        authenticationFailed: "Falha na autenticación",
        authenticationSuccessful: "Autenticación realizada com éxito",
        authenticationError: "Error de autenticación",
        asteriskConnectionSuccess: "Conexión Asterisk estabelecida",
        asteriskConnectionFailed: "Falha na conexión Asterisk",
        ariConnectionEstablished: "Conexión ARI estabelecida",
        ariConnectionError: "Error na conexión ARI",
        performanceTestSuccess: "Teste de performance OK",
        performanceTestFailed: "Falha no teste de performance",
        highLatencyDetected: "Alta latência detectada",
        highLatency: "Alta latência",
        performanceGood: "Performance boa",
        performanceError: "Error de performance",
        functionalTestSuccess: "Teste funcional OK",
        functionalTestFailed: "Falha no teste funcional",
        allFunctionsWorking: "Todas as funciones funcionando",
        functionalError: "Error funcional",
        passed: "Passou",
        failed: "Falhou",
        warning: "Advertencia",
        pending: "Pendiente",
        running: "Executando",
        startTest: "Iniciar Teste",
        retryTest: "Repetir Teste",
        testSummary: "Resumo do Teste",
        connectionMetrics: "Métricas de Conexión",
        testLogs: "Logs do Teste",
        metric: "Métrica",
        value: "Valor",
        // AsteriskSettings main translations
        connectionManagement: "Gerenciamento de Conexiones",
        endpointManagement: "Gerenciamento de Endpoints",
        noConnections: "Nenhuma Conexión",
        noConnectionsDescription: "Você ainda no configurou nenhuma conexión Asterisk",
        noEndpoints: "Nenhum Endpoint",
        noEndpointsDescription: "Você ainda no configurou nenhum endpoint",
        noConnectionsForEndpoints: "Configure uma conexión Asterisk antes de crear endpoints",
        name: "Nombre",
        active: "Activo",
        inactive: "Inactivo",
        edit: "Editar",
        test: "Probar",
        delete: "Eliminar",
        refresh: "Actualizar",
        editEndpoint: "Editar Endpoint",
        newEndpoint: "Novo Endpoint",
        editConnection: "Editar Conexión",
        // AsteriskManagement pages translations
        connections: {
          title: "Conexiones Asterisk",
          addConnection: "Añadir Conexión",
          searchPlaceholder: "Buscar conexiones...",
          lastActivity: "Última Atividade",
          stats: {
            total: "Total de Conexiones",
            connected: "Conectadas",
            disconnected: "Desconectadas",
            inactive: "Inativas",
          },
          selectedCount: "{{count}} conexiones selecionadas",
          noFilterResults: "Nenhuma conexión encontrada com os filtros aplicados",
          noConnections: "Nenhuma conexión configurada",
          deleteTitle: "Eliminar Conexión",
          deleteMultipleTitle: "Eliminar Múltiplas Conexiones",
          deleteConfirm: "¿Estás seguro que quieres eliminar a conexión '{{name}}'?",
          deleteMultipleConfirm: "¿Estás seguro que quieres eliminar {{count}} conexiones selecionadas?",
          bulkConnect: "Conectar Selecionadas",
          bulkDisconnect: "Desconectar Selecionadas",
        },
        endpoints: {
          title: "Endpoints Asterisk",
          addEndpoint: "Añadir Endpoint",
          searchPlaceholder: "Buscar endpoints...",
          technology: "Tecnologia",
          callerid: "Caller ID",
          registered: "Registrado",
          unregistered: "No Registrado",
          noUser: "Sem Usuario",
          noConnection: "Sem Conexión",
          selectedCount: "{{count}} endpoints seleccionados",
          noFilterResults: "Nenhum endpoint encontrado com os filtros aplicados",
          noEndpoints: "Nenhum endpoint configurado",
          deleteTitle: "Eliminar Endpoint",
          deleteMultipleTitle: "Eliminar Múltiplos Endpoints",
          deleteConfirm: "¿Estás seguro que quieres eliminar o endpoint '{{name}}'?",
          deleteMultipleConfirm: "¿Estás seguro que quieres eliminar {{count}} endpoints seleccionados?",
          stats: {
            total: "Total de Endpoints",
            registered: "Registrados",
            unregistered: "No Registrados",
            sipEndpoints: "Endpoints SIP",
          }
        },
        callHistory: {
          title: "Histórico de Chamadas",
          export: "Exportar",
          searchPlaceholder: "Buscar chamadas...",
          filters: {
            today: "Hoje",
            yesterday: "Ontem",
            week: "Esta Semana",
            month: "Este Mês",
            custom: "Personalizado",
          },
          startDate: "Data Início",
          endDate: "Data Fim",
          caller: "Chamador",
          callee: "Chamado",
          endpoint: "Endpoint",
          internal: "Interna",
          recording: "Gravação",
          playRecording: "Reproduzir Gravação",
          downloadRecording: "Baixar Gravação",
          noRecording: "Sem Gravação",
          details: "Detalles",
          selectedCount: "{{count}} chamadas selecionadas",
          noFilterResults: "Nenhuma chamada encontrada com os filtros aplicados",
          noCalls: "Nenhuma chamada no período seleccionado",
          deleteTitle: "Eliminar Chamada",
          deleteMultipleTitle: "Eliminar Múltiplas Chamadas",
          deleteConfirm: "¿Estás seguro que quieres eliminar esta chamada?",
          deleteMultipleConfirm: "¿Estás seguro que quieres eliminar {{count}} chamadas selecionadas?",
          callDetails: "Detalhes da Chamada",
          basicInfo: "Información Básicas",
          participants: "Participantes",
          callId: "ID da Chamada",
          audioNotSupported: "Seu navegador no suporta reprodução de áudio",
          exportTitle: "Exportar Histórico",
          exportDescription: "Selecciona o formato para exportar o histórico de chamadas",
          callback: "Retornar Chamada",
          stats: {
            totalCalls: "Total de Chamadas",
            inbound: "Recebidas",
            missed: "Perdidas",
            avgDuration: "Duración Média",
            totalTime: "Tempo Total",
            today: "hoje",
            ofTotal: "do total",
          },
          emptyState: {
            title: "Nenhuma Conexión Asterisk Configurada",
            description: "Para visualizar o histórico de chamadas, você precisa configurar pelo menos uma conexión Asterisk.",
            action: "Configurar Conexión",
          }
        },
        reports: {
          title: "Informes Asterisk",
          export: "Exportar",
          refreshChart: "Actualizar Gráfico",
          filters: {
            today: "Hoje",
            yesterday: "Ontem",
            thisWeek: "Esta Semana",
            lastWeek: "Semana Passada",
            thisMonth: "Este Mês",
            lastMonth: "Mês Passado",
            custom: "Personalizado",
          },
          startDate: "Data Início",
          endDate: "Data Fim",
          reportType: "Tipo de Informe",
          types: {
            overview: "Vison Geral",
            performance: "Performance",
            usage: "Uso",
            quality: "Qualidade",
          },
          groupBy: "Agrupar Por",
          groupByOptions: {
            hour: "Hora",
            day: "Dia",
            week: "Semana",
            month: "Mês",
          },
          format: "Formato",
          exportTitle: "Exportar Informe",
          exportOptionsLabel: "Opciones de Exportación",
          exportOptions: {
            includeSummary: "Incluir Resumo",
            includeCharts: "Incluir Gráficos",
            includeDetails: "Incluir Detalhes",
            includeKPIs: "Incluir KPIs",
          },
          kpis: {
            totalCalls: "Total de Chamadas",
            answerRate: "Taxa de Atención",
            avgDuration: "Duración Média",
            missedCalls: "Chamadas Perdidas",
            target: "Meta",
            total: "total",
            ofTotal: "do total",
          },
          charts: {
            callTrends: "Tendência de Chamadas",
            callDistribution: "Distribuição de Chamadas",
            callsByEndpoint: "Chamadas por Endpoint",
            callsByHour: "Chamadas por Hora",
          },
          topPerformers: "Top Performers",
          calls: "chamadas",
          alerts: "Alertas",
          noAlerts: "Nenhum alerta no momento",
        },
      },
      helpCenter: {
        title: "Centro de Ayuda",
        welcome: "¿Cómo podemos ayudar?",
        subtitle: "Encuentra guías, tutoriales y documentación completa del sistema",
        sidebarSubtitle: "Encuentra respuestas a tus preguntas",
        search: "Buscar artículos...",
        searchPlaceholder: "Buscar en la documentación...",
        noCategories: "No hay categorías disponibles",
        article: "artículo",
        articles: "artículos",
        articlesAvailable: "artigos disponíveis",
        views: "visualizaciones",
        wasHelpful: "Este artigo foi útil?",
        yes: "Sí",
        no: "No",
        thanksFeedback: "Obligatorio pelo seu feedback!",
        helpful: "acharam útil",
        notHelpful: "no acharam útil",
        articleNotFound: "Artigo no encontrado",
        categoryNotFound: "Categoria no encontrada",
        relatedArticles: "Artigos Relacionadas",
        lastUpdated: "Última actualización",
        subcategories: "Subcategorias",
        noContentYet: "Ainda no há conteúdo aqui",
        contentComingSoon: "O conteúdo se adicionado em breve",
        categories: {
          gettingStarted: "Primeiros Passos",
          service: "Atención",
          automation: "Automatizaciones",
          sales: "Vendas",
          reports: "Informes",
          settings: "Configuraciones",
          integrations: "Integraciones",
          administration: "Administración",
        }
      },
      // End of Help Center translations

      // Help Admin translations
      helpAdmin: {
        title: "Gestionar Artigos de Ajuda",
        newArticle: "Novo Artigo",
        editArticle: "Editar Artigo",
        searchPlaceholder: "Buscar artigos...",
        articleCreated: "Artigo creado com éxito!",
        articleUpdated: "Artigo actualizado com éxito!",
        articleDeleted: "Artigo eliminado com éxito!",
        confirmDeleteTitle: "Eliminar Artigo",
        confirmDeleteMessage: "¿Estás seguro que quieres eliminar este artigo? Esta acción no pode ser desfeita.",
        table: {
          title: "Título",
          category: "Categoria",
          status: "Estado",
          views: "Visualizaciones",
          actions: "Acciones",
        },
        buttons: {
          edit: "Editar",
          delete: "Eliminar",
        },
        form: {
          category: "Categoria",
          slug: "Slug (URL)",
          status: "Estado",
          order: "Ordem",
        }
      },
      // End of Help Admin translations
      sdr: {
        title: "IA SDR",
        searchPlaceholder: "Buscar campanhas...",
        downloadTemplate: "Baixar Template",
        uploadLeads: "Importar Leads",
        leads: "leads",
        qualified: "qualif.",
        meetings: "reuniões",
        conversion: "conv.",
        viewLeads: "Ver Leads",
        tabs: {
          campaigns: "Campanhas",
          analytics: "Analytics",
        },
        stats: {
          totalCampaigns: "Total de Campanhas",
          totalLeads: "Total de Leads",
          qualifiedLeads: "Leads Qualificados",
          meetingsScheduled: "Reuniões Agendadas",
        },
        campaignStatus: {
          draft: "Rascunho",
          active: "Activa",
          paused: "Pausada",
          completed: "Concluída",
          archived: "Arquivada",
        },
        table: {
          name: "Nombre",
          status: "Estado",
          leads: "Leads",
          qualified: "Qualificados",
          meetings: "Reuniões",
          actions: "Acciones",
        },
        analytics: {
          coming: "Analytics em Desenvolvimento",
          description: "Informes detalhados de performance das campanhas estarão disponíveis em breve.",
        },
        modal: {
          createTitle: "Nova Campanha SDR",
          editTitle: "Editar Campanha SDR",
          basicInfo: "Información Básicas",
          name: "Nome da Campanha",
          description: "Descripción",
          status: "Estado",
          assistant: "Asistente IA",
          noAssistant: "Nenhum assistente",
          targetCriteria: "Critérios de Segmentação",
          location: "Localización",
          maxResults: "Máximo de Resultados",
          keywords: "Palavras-chave",
          addJobTitle: "Añadir Cargo",
          addIndustry: "Añadir Indústria",
          messageSequence: "Sequência de Mensajes",
          messageType: "Tipo de Mensaje",
          delayDays: "Delay (dias)",
          messageSubject: "Assunto",
          messageContent: "Conteúdo",
          addMessage: "Añadir Mensaje",
          validation: {
            nameRequired: "Nombre de la campaña é obrigatório",
          }
        },
        messageTypes: {
          initial_contact: "Contato Inicial",
          follow_up: "Follow-up",
          meeting_request: "Solicitação de Reunião",
        },
        upload: {
          title: "Importar Leads",
          selectCampaign: "Selecionar Campanha",
          dropFileHere: "Clique ou arraste o archivo aqui",
          supportedFormats: "Formatos suportados: CSV, XLS, XLSX",
          maxFileSize: "Tamanho máximo: 10MB",
          options: "Opciones de Importación",
          skipDuplicates: "Pular leads duplicados",
          validateEmails: "Validar emails",
          processing: "Processando archivo...",
          results: "Resultados da Importación",
          imported: "importados",
          skipped: "ignorados",
          duplicates: "duplicatas",
          errors: "errores",
          errorDetails: "Detalhes dos Errores",
          row: "Linha",
          moreErrors: "E mais {{count}} errores...",
          upload: "Importar",
          invalidFileType: "Tipo de archivo no suportado. Use CSV, XLS ou XLSX.",
          fileTooLarge: "Archivo muito grande. Máximo 10MB.",
          validation: {
            missingFields: "Selecciona uma campanha e um archivo para continuar.",
          }
        },
        toasts: {
          campaignCreated: "Campanha creada com éxito!",
          campaignUpdated: "Campanha atualizada com éxito!",
          campaignDeleted: "Campanha removida com éxito!",
          templateDownloaded: "Template baixado com éxito!",
        },
        confirmationModal: {
          deleteCampaign: {
            title: "Confirmar Eliminación",
            message: "¿Estás seguro que quieres eliminar a campanha '{{name}}'? Esta acción no pode ser desfeita.",
          }
        },
        campaigns: {
          title: "Campañas SDR",
          searchPlaceholder: "Buscar campañas...",
          buttons: {
            add: "Nueva Campaña",
            upload: "Importar Leads",
            viewLeads: "Ver Leads"
          },
          table: {
            name: "Nombre",
            status: "Estado",
            totalProspects: "Total Leads",
            qualified: "Calificados",
            contacted: "Contactados",
            startDate: "Fecha de Inicio",
            actions: "Acciones"
          },
          status: {
            active: "Activa",
            paused: "Pausada",
            completed: "Completada",
            draft: "Borrador"
          },
          toasts: {
            deleted: "¡Campaña eliminada con éxito!",
            deletedTitle: "Campaña Eliminada"
          },
          confirmationModal: {
            deleteTitle: "Eliminar campaña",
            deleteMessage: "¿Estás seguro de que deseas eliminar esta campaña? Esta acción no se puede deshacer."
          }
        },
        leads: {
          title: "Leads de la Campaña",
          searchPlaceholder: "Buscar leads...",
          total: "Total",
          qualified: "Calificados",
          contacted: "Contactados",
          linkedin: "LinkedIn",
          noLeads: "No se encontraron leads",
          tabs: {
            all: "Todos",
            qualified: "Calificados",
            contacted: "Contactados",
            responded: "Respondidos",
            disqualified: "Descalificados"
          },
          table: {
            name: "Nombre",
            company: "Empresa",
            title: "Cargo",
            contact: "Contacto",
            score: "Puntuación",
            status: "Estado",
            lastContact: "Último Contacto",
            actions: "Acciones"
          },
          status: {
            pending: "Pendiente",
            qualified: "Calificado",
            contacted: "Contactado",
            responded: "Respondió",
            disqualified: "Descalificado",
            meeting_scheduled: "Reunión Agendada"
          },
          actions: {
            requalify: "Recalificar",
            contact: "Contactar",
            schedule: "Programar Reunión"
          },
          toasts: {
            requalified: "¡Lead recalificado con éxito!",
            deleted: "¡Lead eliminado con éxito!"
          }
        }
      },
    nappSettings: {
      sections: {
        basicConfig: "Configuración Básica",
        automation: "Automatización",
        notifications: "Notificaciones",
        ticketCreation: "Creación de Tickets"
      },
      fields: {
        integrationToken: "Token de Integración",
        syncInterval: "Intervalo de Sincronización",
        feedLimit: "Límite de Pedidos",
        active: "Activo",
        enableNotifications: "Habilitar Notificaciones",
        autoCreateContacts: "Crear Contactos Automáticamente",
        autoCreateTickets: "Crear Tickets Automáticamente"
      },
      help: {
        integrationToken: "Token proporcionado por NAPP Solutions para integración",
        syncInterval: "Intervalo en minutos para sincronización automática de pedidos",
        feedLimit: "Número máximo de pedidos para elbtener en cada sincronización",
        notificationStatuses: "Seleccione los estados de pedido que deben generar notificaciones",
        ticketStatuses: "Seleccione los estados de pedido que deben crear tickets automáticamente"
      },
      status: {
        invalidConfig: "Configuración Inválida",
        notConfigured: "No Configurado",
        testingConnection: "Probando conexión con NAPP..."
      },
      errors: {
        testFailed: "Prueba de conexión fallida",
        fetchFailed: "Error al obtener datos"
      },
      actions: {
        saveConfig: "Guardar Configuración",
        testConnection: "Probar Conexión"
      }
    },
    utm: {
      filters: {
        source: "Fuente UTM",
        campaign: "Campaña UTM",
        loading: "Cargando...",
        noSources: "Ninguna fuente encontrada",
        noCampaigns: "Ninguna campaña encontrada"
      },
      generator: {
        title: "Generador de Enlaces UTM",
        recipientData: "Datos del Destinatario",
        phoneNumber: "Número de WhatsApp",
        phoneHelper: "Formato: 5511999999999 (código de país + código de área + número)",
        message: "Mensaje (Opcional)",
        messageHelper: "Mensaje prellenado en WhatsApp",
        messagePlaceholder: "¡Hola! Vine a través del enlace...",
        requiredParams: "Parámetros UTM Obligatorios",
        source: "Fuente (utm_source)",
        sourceHelper: "Origen del tráfico (ej: facebook, google, instagram)",
        campaign: "Campaña (utm_campaign)",
        campaignHelper: "Nombre de la campaña (ej: promo_blackfriday, lanzamiento_producto)",
        optionalParams: "Parámetros UTM Opcionales",
        medium: "Medio (utm_medium)",
        mediumHelper: "Tipo de medio (ej: cpc, banner, email)",
        term: "Término (utm_term)",
        termHelper: "Palabras clave de búsqueda pagada",
        content: "Contenido (utm_content)",
        contentHelper: "Diferenciar anuncios (ej: variacion_a, boton_azul)",
        generateLink: "Generar Enlace",
        generatedLink: "Enlace Generado",
        copyLink: "Copiar Enlace",
        openWhatsApp: "Abrir en WhatsApp",
        linkCopied: "¡Enlace copiado al portapapeles!",
        createdLinks: "Enlaces Creados",
        noLinks: "Ningún enlace creado aún",
        validation: {
          phoneRequired: "El número de WhatsApp es obligatorio",
          sourceRequired: "La fuente (utm_source) es obligatoria",
          campaignRequired: "La campaña (utm_campaign) es obligatoria",
          fillRequired: "Complete todos los campos obligatorios"
        }
      },
      dashboard: {
        title: "Dashboard UTM",
        period: "Período de Análisis",
        dateStart: "Fecha Inicial",
        dateEnd: "Fecha Final",
        loadReport: "Cargar Informe",
        cards: {
          totalContacts: "Total de Contactos",
          totalTickets: "Total de Tickets",
          totalSources: "Fuentes Únicas",
          totalCampaigns: "Campañas Únicas"
        },
        metricsTable: "Métricas Detalladas",
        export: "Exportar CSV",
        noData: "No se encontraron datos para el período seleccionado",
        noDataToExport: "No hay datos para exportar",
        exportSuccess: "¡Informe exportado con éxito!",
        table: {
          source: "Fuente",
          campaign: "Campaña",
          contacts: "Contactos",
          tickets: "Tickets",
          open: "Abiertos",
          closed: "Cerrados",
          firstContact: "Primer Contacto",
          lastContact: "Último Contacto"
        }
      }
    },
  },
}

export { messages };

